<template>
  <div id="enrollCEE" class="div_card">    
    <div v-if="1 == saveFg">
      <br />
      <font style="font-size:x-large; color:#a61b29;">恭喜您完成勤益科大{{setting.sysTitle[0].codeName}}網路報名</font>
      <br />
      <table style="border:2.5px solid;padding:5px;" rules="all" cellpadding='5'>
        <tr>
          <td style="padding: 0.5em; text-align: right;">
            您的報名編號
          </td>
          <td style="padding: 0.5em;">{{inputData.regNo}}</td>
        </tr>
        <tr>
          <td style="padding: 0.5em; text-align: right;">姓名</td>
          <td style="padding: 0.5em;">
            <span class="badge badge-info" style="font-size:1.25rem">{{inputData.name}}</span>
          </td>
        </tr>
        <tr>
          <td style="padding: 0.5em; text-align: right;">注意事項</td>
          <td style="padding: 0.5em;">
            <p v-html="successMsg[0].contText" style="font-size:14px;padding: 0.25em 0.25em 0 0.25em;"
              v-if="successMsg!=null"></p>
          </td>
        </tr>
      </table>
    </div>
    <div v-if="2 == saveFg">
      <br />
      <font style="font-size: 2em; padding: 1em; font-weight: bold;">對不起，本階段報名時間已過!</font>
      <br />
    </div>
    <div style="padding: 0.2em;"
         v-if="0 == saveFg">
      <el-steps :active="active" finish-status="success">
        <el-step :title="item.title"
          v-for="item in tabsData"
          :key="item.pageId"
          :icon="item.icon"
          v-show="checkEditMode()&&inputData.eMode!=1"></el-step>
      </el-steps>
      <el-tabs type="border-card" v-model="activeName" @tab-click="changePage">
        <el-tab-pane name="P0" key="0" :disabled="tabsData[0].disabled" >
          <span slot="label"><i :class="tabsData[0].icon"></i>{{tabsData[0].title}}</span>
          <div class="template-div">
            <table style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;" rules="all">
                  <tbody>
                    <tr style="background: #e9e9e9; height: 2.5em;">
                      <td class="ncut-page-title-text" colspan="8">考生基本資料(碩專)</td>
                    </tr>
                    <tr>
                      <td class="ncut-base-form-title ncut-require-title" style="width:8.5em;">身分證字號</td>
                      <td class="ncut-ipnut-form-text">
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          {{inputData.idNo}}
                        </div>
                      </td>
                      <td class="ncut-base-form-title ncut-require-title" style="width:8.5em;">姓名</td>
                      <td class="ncut-ipnut-form-ipt" colspan="5">
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <el-input v-model="inputData.name" placeholder="請輸入姓名" style="width: 10em; display: inline; " maxlength="20"
                            :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                        </div>
                      </td>  
                    </tr>
                    <tr>
                      <td class="ncut-base-form-title ncut-require-title" style="width:8.5em;">性別</td>
                      <td class="ncut-ipnut-form-ipt">
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <el-radio-group v-model="inputData.sex"
                            :disabled="!checkEditMode()||inputData.eMode==1">
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="2">女</el-radio>
                          </el-radio-group>
                        </div>
                      </td>
                      <td class="ncut-base-form-title ncut-require-title">出生年月日</td>
                      <td class="ncut-ipnut-form-ipt" colspan="2" >
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <span v-if="!checkEditMode()||inputData.eMode==1">{{getCHTDate(inputData.birth, 1)}}</span>
                          <p class="enroll-p"
                            v-if="checkEditMode()&&inputData.eMode==0">
                            <el-date-picker
                              style="width:10em;"
                              v-model="inputData.birth"
                              type="date"
                              placeholder="請選擇出生年月日"
                              :clearable="false"
                              :disabled="!checkEditMode()||inputData.eMode==1">
                            </el-date-picker>
                          </p>
                        </div>
                      </td>
                      <td class="ncut-base-form-title ncut-require-title">低/中低收入戶</td>
                      <td class="ncut-ipnut-form-ipt" colspan="2">  
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <!-- <el-checkbox v-model="inputData.isLowIncome"
                            :disabled="!checkEditMode()||inputData.eMode==1">&nbsp;<span class="ncut-ipnut-form-text">低/中低收入戶</span> </el-checkbox> -->
                            <el-select v-model="inputData.isLowIncome" placeholder="請選擇"
                            :disabled="!checkEditMode()">
                            <el-option
                              v-for="item in LowIncomeOpt"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="ncut-base-form-title ncut-require-title" style="padding:0.1em 0.5em 0.1em 0;">戶籍地址<br /><font style="font-size:small;">(永久地址)</font></td>
                      <td class="ncut-ipnut-form-ipt" colspan="7"> 
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <span class="ncut-ipnut-form-text">縣市鄉鎮代碼</span>&nbsp;
                          <el-select v-model="inputData.resCity" placeholder="請選擇縣市"
                              style="width: 8em;"
                              @change="districtItem1=null; inputData.resDistrict=null; getResDistrictItem();"
                              :disabled="!checkEditMode()||inputData.eMode==1"
                              v-if="cityItem!=null">
                              <el-option
                                v-for="item in cityItem"
                                :key="item.codeNo"
                                :label="item.zipName"
                                :value="item.codeNo">
                              </el-option>
                              <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                          </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-select v-model="inputData.resDistrict" placeholder="請選擇鄉鎮"
                              style="width: 8em;"
                              :disabled="!checkEditMode()||inputData.eMode==1||districtItem1==null">
                              <el-option
                                v-for="item in districtItem1"
                                :key="item.codeNo"
                                :label="item.zipName"
                                :value="item.codeNo">
                              </el-option>
                              <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                          </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-input v-model="inputData.resAddress" placeholder="請輸入地址" style="width: 30em; display: inline; " maxlength="60"
                            :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="ncut-base-form-title ncut-require-title" style="padding:0.1em 0.5em 0.1em 0; vertical-align: middle;">通訊地址<br /><font style="font-size:small;">(9月底前可聯絡地址)</font></td>
                      <td class="ncut-ipnut-form-ipt" colspan="7">
                        <el-checkbox v-model="addressFg"
                          v-if="checkEditMode()&&inputData.eMode!=1"
                          @change="copyAddress()">&nbsp;<span class="ncut-ipnut-form-text">同戶籍地址</span>
                        </el-checkbox>
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <span class="ncut-ipnut-form-text">縣市鄉鎮代碼</span>&nbsp;
                          <el-select v-model="inputData.mailCity" placeholder="請選擇縣市"
                              style="width: 8em;"
                              @change="districtItem2=null; inputData.mailDistrict=null; getMailDistrictItem();"
                              :disabled="!checkEditMode()||inputData.eMode==1"
                              v-if="cityItem!=null">
                              <el-option
                                v-for="item in cityItem"
                                :key="item.codeNo"
                                :label="item.zipName"
                                :value="item.codeNo">
                              </el-option>
                              <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                          </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-select v-model="inputData.mailDistrict" placeholder="請選擇鄉鎮"
                              style="width: 8em;"
                              :disabled="!checkEditMode()||inputData.eMode==1||districtItem2==null">
                              <el-option
                                v-for="item in districtItem2"
                                :key="item.codeNo"
                                :label="item.zipName"
                                :value="item.codeNo">
                              </el-option>
                              <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                          </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-input v-model="inputData.mailAddress" placeholder="請輸入地址" style="width: 30em; display: inline; " maxlength="60"
                            :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="ncut-base-form-title ncut-require-title">聯絡電話(日)</td>
                      <td class="ncut-ipnut-form-ipt">
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <el-input v-model="inputData.phoneNo1" placeholder="請輸入聯絡電話(日)" style="width: 10em; display: inline; " maxlength="20"
                            :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                        </div>
                      </td> 
                      <td class="ncut-base-form-title ncut-require-title">手機號碼</td>
                      <td class="ncut-ipnut-form-ipt" colspan="2">
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <el-input v-model="inputData.phoneNo2" placeholder="請輸入請輸入手機號碼" style="width: 10em; display: inline; " maxlength="20"
                            :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                        </div>
                      </td> 
                      <td class="ncut-base-form-title ncut-require-title">E-mail</td>
                      <td class="ncut-ipnut-form-ipt" colspan="2">
                        <div class="input-group" style="display:flex; padding:0.2em;">
                          <el-input v-model="inputData.eMail" placeholder="請輸入E-mail" style="width: 15em; display: inline; " maxlength="30"
                            :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="ncut-base-form-title ncut-require-title">上傳照片</td>
                      <td class="ncut-ipnut-form-ipt" colspan="2" style="vertical-align: top; padding:0.1em;">
                        <span v-if="!(checkEditMode()&&inputData.eMode!=1) && (inputData.info1 != null) && (inputData.info1.length > 0)&&(inputData.info1[0].img != null)">
                          <img :src="inputData.info1[0].img" style="width: 8em;" />
                        </span>
                        <el-upload
                          ref="upload"
                          action="./WebApi/Tools/UploadV2"
                          accept=".jpg"
                          :name="'f' + inputData.documentID + '_1'"
                          :show-file-list="false"
                          :drag="true"
                          :on-success="handleAvatarSuccess"
                          :before-upload="onBeforeUploadF1"
                          v-if="checkEditMode()&&inputData.eMode!=1">
                          <img v-if="imageUrl!=null" :src="imageUrl" class="avatar"/>
                          <img v-else-if="(imageUrl== null)&& (inputData!=null) && (inputData.info1!=null) && (inputData.info1.length > 0)&&(inputData.info1[0].img != null)&&(inputData.info1[0].status!='R')" 
                              :src="inputData.info1[0].img" class="avatar"/>
                          <i class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </td>
                      <td class="ncut-ipnut-form-ipt" colspan="5" style="background:#f0f5e5;">
                        <div style="display: block; font-size:0.9rem;">
                          <p v-html="successMsg[2].contText" style="font-size:14px;padding: 0.25em 0.25em 0 0.25em;"
                            v-if="successMsg!=null"></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="ncut-base-form-title ncut-require-title">上傳身分證<br />正反面影本</td>
                      <td class="ncut-ipnut-form-ipt" colspan="2" style="vertical-align: top;">
                        <ul style="clear:both" v-if="(inputData.info2 != null) && (inputData.info2.length > 0)" class="response">
                          <li class="sel-file" v-for="(f,index) in filterImg2List" :key="index" :index="'0'+index" :name="'ID'+index">
                            <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                            </a>
                            &nbsp;&nbsp;<i class="el-icon-delete"
                                          @click="setDelFlag(f)"
                                          v-if="checkEditMode()&&inputData.eMode!=1"></i>
                          </li>
                        </ul>
                        <el-upload
                          ref="upload"
                          action="./WebApi/Tools/UploadV2"
                          accept=".jpg,.pdf"
                          :name="'f' + inputData.documentID + '_8' + (info2==null?0:info2.length)"
                          :on-success="handleAvatarSuccess"
                          :on-remove="handleChangeF2"
                          :before-upload="onBeforeUploadF2"
                          v-if="checkEditMode()&&inputData.eMode!=1">
                          <el-button size="small" type="primary">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                        </el-upload>
                      </td>
                      <td class="ncut-ipnut-form-ipt" colspan="4" style="background:#f0f5e5;">
                        <div style="display: block; font-size:0.9rem;">                        
                          上傳之影本格式：
                          <ul style="list-style-type:disc; margin-bottom: 0;">
                            <li><b style="color: #CC3300;">可以選擇一或多個檔案 (正面/反面)。</b></li>
                            <li>請先將上傳檔案放置於桌面。</li>
                            <li>副檔名 .pdf, .jpg。</li>
                            <li>檔案大小不得超過2MB。</li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                    <tr style="background: #e9e9e9; height: 2.5em;">
                      <td class="ncut-page-title-text ncut-input-title" colspan="8">家長或緊急連絡人</td>
                    </tr>
                    <tr>
                        <td class="ncut-base-form-title ncut-require-title">姓名</td>
                        <td class="ncut-ipnut-form-ipt">
                          <div class="input-group" style="display:flex; padding:0.2em;">
                            <el-input v-model="inputData.emeName" placeholder="請輸入姓名" style="width: 10em; display: inline; " maxlength="20"
                              :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                          </div>
                        </td>
                        <td class="ncut-base-form-title ncut-require-title">關係</td>
                        <td class="ncut-ipnut-form-ipt" colspan="2">
                          <div class="input-group" style="display:flex; padding:0.2em;">
                            <el-input v-model="inputData.emeRelation" placeholder="請輸入關係" style="width: 8em; display: inline; " maxlength="10"
                              :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                          </div>
                        </td> 
                        <td class="ncut-base-form-title ncut-require-title">聯絡電話</td>
                        <td class="ncut-ipnut-form-ipt" colspan="2">
                          <div class="input-group" style="display:flex; padding:0.2em;">
                            <el-input v-model="inputData.emePhone" placeholder="請輸入聯絡電話" style="width: 10em; display: inline; " maxlength="20"
                              :disabled="!checkEditMode()||inputData.eMode==1"></el-input>
                          </div>
                        </td>
                      </tr>
                  </tbody>
            </table>
            <br />
            <div class="ncut-base-form-button" style="text-align: center;"
              v-if="(0==inputData.isApproval)">
              <el-button type="primary" @click="nextPage(1)">{{$t('message.Next_txt')}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>&nbsp;&nbsp;&nbsp;&nbsp;
              <el-button type="success" @click="keep()" v-if="checkEditMode()">{{$t('message.Keep_txt')}}</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="P1" key="1" :disabled="tabsData[1].disabled" >
          <span slot="label"><i :class="tabsData[1].icon"></i>{{tabsData[1].title}}</span>
          <modals-container/>
          <table class="w-100-input" style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;" rules="all" >
            <tbody>
              <tr style="background: #e9e9e9; height: 2.5em;">
                <td class="ncut-page-title-text ncut-input-title" colspan="5">考生報考資料</td>
              </tr>
              <tr>
                <td class="ncut-base-form-title ncut-require-title" style="width:9em;">報考身份</td>
                <td class="ncut-ipnut-form-ipt" colspan="2" style="vertical-align: text-top;padding: 0.75em;">
                  <p class="input-group enroll-p">
                    <el-select v-model="inputData.ideID" placeholder="請選擇報考身份"
                      style="width: 20em;"
                      @change="setIdenMsg();"
                      :disabled="!checkEditMode()"
                      v-if="idenItem!=null">
                      <el-option key="0" label=" " :value="0" :disabled="true">
                      </el-option>
                      <el-option
                        v-for="item in idenItem"
                        :key="item.idenID"
                        :label="item.idenDesc"
                        :value="item.idenID">
                      </el-option>
                    </el-select>
                  </p>
                </td>
                <td class="ncut-base-form-title ncut-require-title">報考資格</td>
                <td class="ncut-ipnut-form-ipt" colspan="2" style="vertical-align: text-top;padding: 0.75em;">
                  <p class="input-group enroll-p">
                    <el-select v-model="inputData.qId" placeholder="請選擇報考資格"
                      style="width: 20em;"
                      :disabled="!checkEditMode()"
                      v-if="qualItem!=null">
                      <el-option key="0" label=" " :value="0" :disabled="true"/>
                      <el-option
                        v-for="item in qualItem"
                        :key="item.qId"
                        :label="item.no+' '+item.name"
                        :value="item.qId">
                      </el-option>
                    </el-select>
                  </p>
                  <span style="color:#ec2c64;">
                    {{qualStr}}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title ncut-require-title">畢肄業學校</td>
                <td class="ncut-ipnut-form-ipt" colspan="2">
                  <p class="input-group enroll-p">
                    <span v-if="!checkEditMode()||inputData.eMode==1" style="height: 2em;">{{showSchool}}</span>
                    <span v-if="checkEditMode()&&inputData.eMode!=1">
                      <el-button size="medium" style=" min-width: 15em; text-align: left;">{{showSchool}}</el-button>
                      <el-button size="mini" type="primary" round @click="showSchoolModal()" style="padding: 0.8125em;">選擇<i class="el-icon-more el-icon--right"/></el-button>
                      <el-input v-model="inputData.othrInfo.schoolExtra" placeholder="請輸入畢肄業學校" style="width: 10em; display: inline; " maxlength="50"></el-input>
                    </span>
                  </p>
                </td>
                <td class="ncut-base-form-title ncut-require-title" style="width:8.5em;">畢肄業系科</td>
                <td class="ncut-ipnut-form-ipt" colspan="1">
                  <p class="input-group enroll-p">
                    <span v-if="!checkEditMode()||inputData.eMode==1" style="height: 2em;">{{showDept}}</span>
                    <span v-if="checkEditMode()&&inputData.eMode!=1">
                      <el-button size="medium" style=" min-width: 15em; text-align: left;">{{showDept}}</el-button>
                      <el-button size="mini" type="primary" round @click="showDeptModal()" style="padding: 0.8125em;">選擇<i class="el-icon-more el-icon--right"/></el-button>
                      <el-input v-model="inputData.othrInfo.deptExtra" placeholder="請輸入畢肄業系科" style="width: 10em; display: inline; " maxlength="50"></el-input>
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title">畢肄業年月<br /><span style="font-size: medium;padding: 0.3em;color: navy;">肄業生免填本欄</span></td>
                <td class="ncut-ipnut-form-ipt" colspan="4">
                  <p class="input-group enroll-p">
                    <span v-if="!checkEditMode()||inputData.eMode==1">{{gradTimeCHT}}</span>
                    <el-date-picker
                      v-model="inputData.gradTime"
                      style="width:10em;"
                      type="month"
                      placeholder="請輸入畢肄業年月"
                      :clearable="false"
                      v-if="checkEditMode()&&inputData.eMode!=1">
                    </el-date-picker>
                  </p>                              
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title ncut-require-title">上傳學歷<br />證明文件</td>
                <td class="ncut-ipnut-form-ipt" colspan="2" style="vertical-align: top;">
                  <ul style="clear:both" v-if="(inputData.info3!=null) && (inputData.info3.length > 0)" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg3List" :key="index" :index="'0'+index" :name="'PH'+index">
                      <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                      &nbsp;&nbsp;<i class="el-icon-delete"
                                    @click="setDelFlag(f)"
                                    v-if="checkEditMode()&&inputData.eMode!=1"></i>
                    </li>
                  </ul>
                  <el-upload
                    ref="upload"
                    action="./WebApi/Tools/UploadV2"
                    accept=".pdf"
                    :name="'f' + inputData.documentID + '_2' + (info3==null?0:info3.length)"
                    :on-success="handleAvatarSuccess"
                    :on-remove="handleChangeF3"
                    :before-upload="onBeforeUploadF3"
                    v-if="checkEditMode()&&inputData.eMode!=1">
                    <el-button size="small" type="primary">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                  </el-upload>
                </td>
                <td class="ncut-ipnut-form-ipt" colspan="4" style="background:#f0f5e5;">
                  <div style="display: block; font-size:0.9rem;">                        
                    檔案格式：
                    <p v-html="successMsg[4].contText" style="font-size:14px;padding: 0.25em 0.25em 0 0.25em;"
                      v-if="successMsg!=null"></p>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" 
                    v-bind:style="{'color': labelColor}">上傳歷年<br />成績單</td>
                <td class="ncut-ipnut-form-ipt" colspan="2" style="vertical-align: top;">
                  <ul style="clear:both" v-if="(inputData.info6!=null) && (inputData.info6.length > 0)" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg6List" :key="index" :index="'0'+index" :name="'TR'+index">
                      <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                      &nbsp;&nbsp;<i class="el-icon-delete"
                                    @click="setDelFlag(f)"
                                    v-if="checkEditMode()"></i>
                    </li>
                  </ul>
                  <el-upload
                    ref="upload"
                    action="./WebApi/Tools/UploadV2"
                    accept=".pdf"
                    :name="'f' + inputData.documentID + '_3' + (info8==null?0:info8.length)"
                    :on-success="handleAvatarSuccess"
                    :on-remove="handleChangeF8"
                    :before-upload="onBeforeUploadF8"
                    v-if="checkEditMode()">
                    <el-button size="small" type="primary">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                  </el-upload>
                </td>
                <td class="ncut-ipnut-form-ipt" colspan="4" style="background:#f0f5e5;">
                  <div style="display: block; font-size:0.9rem;">                        
                    檔案格式：
                    <ul style="list-style-type:disc; margin-bottom: 0;"> 
                      <li>請先將上傳檔案放置於桌面。</li>
                      <li>副檔名 .pdf。</li>
                      <li>單一檔案大小不得過2MB。</li> 
                    </ul>
                  </div>
                </td>
              </tr>
              <tr style="background: #e9e9e9; height: 2.5em;">
                <td class="ncut-page-title-text ncut-input-title" colspan="5">在職證明</td>
              </tr>
              <tr>
                <td class="ncut-base-form-title ncut-require-title">現任服務單位</td>
                <td class="ncut-ipnut-form-ipt" colspan="2">
                  <div class="input-group" style="display:flex; padding:0.2em;">
                    <el-input v-model="inputData.othrInfo.coName" placeholder="請輸入服務單位" style="width: 20em; display: inline;"
                              :disabled="!checkEditMode()"></el-input>
                  </div>
                </td>
                <td class="ncut-base-form-title ncut-require-title" style="width:8.5em;">職稱</td>
                <td class="ncut-ipnut-form-ipt" colspan="1">
                  <div class="input-group" style="display:flex; padding:0.2em;">
                    <el-input v-model="inputData.othrInfo.title" placeholder="請輸入職稱" style="width: 10em; display: inline;"
                              :disabled="!checkEditMode()"></el-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title ncut-require-title">現任公司<br />服務期間</td>
                <td class="ncut-ipnut-form-ipt" colspan="4" style="padding: 0.75em 0 0 0;">
                  <div class="input-group" style="display:flex;">
                    <span style="padding:0.6em 0.2em;">現任公司服務期間</span>
                    <span style="padding:0.6em 0.1em; color:#CA6924; font-weight:bolder;" 
                      v-if="!checkEditMode()">{{getCHTDate(inputData.othrInfo.startData, 1)}}</span>
                    <el-date-picker
                      v-model="inputData.othrInfo.startData"
                      style="width:10em;"
                      type="date"
                      placeholder="請選擇服務期間(起)"
                      :clearable="false"
                      v-else>
                    </el-date-picker>
                    <span style="padding:0.6em 0.2em;">- 迄今</span>
                    <ul>
                      <li>
                        共 <el-input-number v-model="inputData.othrInfo.yy" controls-position="right" :min="0" :max="100" label="年" size="small" style="width: 6.5em;"
                              :disabled="!checkEditMode()"></el-input-number> 年 <el-input-number v-model="inputData.othrInfo.mm" controls-position="right" :min="0" :max="12" label="月" size="small" style="width: 6em;"
                              :disabled="!checkEditMode()"></el-input-number> 月。(考生自填)
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title ncut-require-title">上傳在職證明</td>
                <td class="ncut-ipnut-form-ipt" colspan="2" style="vertical-align: top;">
                  <ul style="clear:both" v-if="(inputData.info7!=null) && (inputData.info7.length > 0)" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg7List" :key="index" :index="'0'+index" :name="'EC'+index">
                      <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                      &nbsp;&nbsp;<i class="el-icon-delete"
                                    @click="setDelFlag(f)"
                                    v-if="checkEditMode()"></i>
                    </li>
                  </ul>
                  <el-upload
                    ref="upload"
                    action="./WebApi/Tools/UploadV2"
                    accept=".pdf"
                    :name="'f' + inputData.documentID + '_12' + (info9==null?0:info9.length)"
                    :on-success="handleAvatarSuccess"
                    :on-remove="handleChangeF9"
                    :before-upload="onBeforeUploadF9"
                    v-if="checkEditMode()">
                    <el-button size="small" type="primary">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                  </el-upload>
                </td>
                <td class="ncut-ipnut-form-ipt" colspan="2" style="background:#f0f5e5;">
                  <div style="display: block; font-size:0.9rem;">                        
                    檔案格式：
                    <ul style="list-style-type:disc; margin-bottom: 0;"> 
                      <li>請上傳在職服務證明書或投保證明(如:勞保明細表)。</li>
                      <li>副檔名 .pdf。</li>
                      <li>單一檔案大小不得過2MB。</li> 
                    </ul>
                  </div>
                </td>
              </tr>
              <tr style="background: #e9e9e9; height: 2.5em;">
                <td class="ncut-page-title-text ncut-input-title" colspan="5">考場協助</td>
              </tr>
              <tr>
                <td class="ncut-ipnut-form-ipt" colspan="3" style="padding: 0.75em 0 0 0; border-right: 0px none white; vertical-align: top;">
                  <el-checkbox v-model="inputData.othrInfo.impaFlag"
                      :disabled="!checkEditMode()">&nbsp;<span class="ncut-ipnut-form-text">需申請考場協助者，請上傳申請表及身心障礙證明。</span>
                    </el-checkbox>
                    <br/>
                    <p v-html="successMsg[5].contText" style="font-size:14px;padding: 0.25em 0.25em 0 0.25em;"
                      v-if="successMsg!=null"
                      v-show="inputData.othrInfo.impaFlag"></p>
                </td>
                <td class="ncut-ipnut-form-ipt" colspan="2" style="padding: 0.75em 0 0 0; border-left: 0px none white;">
                  <div class="input-group" style="display:flex; padding:0.2em;width:100%;">                    
                    <div
                      v-show="inputData.othrInfo.impaFlag">
                      <!-- 請自行註明協助事項(100字內) -->                       
                      <el-input maxlength="100" placeholder="考生自填" style="width: 20em; display: inline;"
						            v-model="inputData.othrInfo.impaMemo"
                        :disabled="!checkEditMode()"
                        show-word-limit></el-input>
                      <ul style="clear:both" v-if="(inputData.info8 != null) && (inputData.info8.length > 0)" class="response">
                        <li class="sel-file" v-for="(f,index) in filterImg8List" :key="index" :index="'0'+index" :name="'ID'+index">
                          <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                            <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                            <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                          </a>
                          &nbsp;&nbsp;<i class="el-icon-delete"
                                        @click="setDelFlag(f)"
                                        v-if="checkEditMode()&&inputData.eMode!=1"></i>
                        </li>
                      </ul>
                      <el-upload style="padding:1em;"
                        ref="upload"
                        action="./WebApi/Tools/UploadV2"
                        accept=".pdf"
                        :name="'f' + inputData.documentID + '_13' + (info10==null?0:info10.length)"
                        :on-success="handleAvatarSuccess"
                        :on-remove="handleChangeF10"
                        :before-upload="onBeforeUploadF10"
                        v-if="checkEditMode()">
                        <el-button size="small" type="primary">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                      </el-upload>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div class="ncut-base-form-button" style="text-align: center;"
            v-if="(0==inputData.isApproval)">
            <el-button-group>
              <el-button type="primary" @click="prevPage(1)" icon="el-icon-arrow-left">{{$t('message.Back_txt')}}</el-button>
              <el-button type="primary" @click="nextPage(1)">{{$t('message.Next_txt')}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </el-button-group>&nbsp;&nbsp;&nbsp;&nbsp;
            <!-- <el-button type="primary" plain @click="nextPage(1)">下一步</el-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <el-button type="success" @click="keep()" v-if="checkEditMode()">{{$t('message.Keep_txt')}}</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane name="P2" key="2" :disabled="tabsData[2].disabled" >
          <span slot="label"><i :class="tabsData[2].icon"></i>{{tabsData[2].title}}</span>
          <table>
                <tr>
                  <td class="ncut-base-form-ipt doc-title" style="color:#60281E;">
                    <i class="el-icon-document"></i> 其他證明文件：
                  </td>
                  <td class="ncut-base-form-ipt" colspan="2">
                    <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                       class="btn btn-info btn-md"
                       v-if="checkEditMode()"
                       @click="addDocRow()">
                      <i class="el-icon-circle-plus-outline"></i>新增其他證明文件
                    </a>
                  </td>
                </tr>
                <tr>
                  <td class="ncut-base-form-ipt" style="padding: 0.5em;" colspan="3">                
                    <table class="table table-bordered table-striped" style="background:#FFFFFF; width:100%;">
                      <tbody>
                        <tr v-for="(item,othIndex) in inputData.othersInfo" :key="othIndex" :index="'0'+othIndex" :name="'O'+othIndex">
                          <td style="width:9em;">
                            其他證明文件{{othIndex+1}}
                          </td>
                          <td style="width:16em;">
                            <el-input v-model="item.descr" placeholder="請輸入文件名稱" style="width: 15.75em; display: inline; " maxlength="20"
                              :disabled="!checkEditMode()"
                              @change="item.status=(item.status=='A'?item.status:'M')"></el-input>
                          </td>
                          <td style="min-width:25em; margin:0;">
                            <ul style="clear:both" class="response" 
                              v-if="item!=null && item.info!=null && item.info.length > 0">
                              <li class="sel-file" 
                                v-for="(fi,f2Index) in item.info" :key="f2Index" :index="'0'+f2Index" :name="'F5'+f2Index">
                                  <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                        v-if="fi.status=='R'">
                                    刪除…
                                  </span>
                                  <span v-else>
                                    <a :href="'./WebApi/Tools/GetDocument/'+fi.rowId" target="_blank">
                                      <img v-if="fi.img != null" :src="fi.img" style="width: 2em;" />
                                      <img v-if="fi.img == null" src="@/assets/images/disk.png" /> {{fi.name}}{{fi.ext}}
                                    </a>
                                    &nbsp;&nbsp;
                                    <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                                      <el-button icon="el-icon-delete" circle
                                         @click="setModifyFlag(item);setDelFlag(fi);"
                                         v-if="checkEditMode()&&item.status!='R'"></el-button>
                                    </el-tooltip>
                                  </span>
                              </li>
                            </ul>
                            <el-tooltip class="item" style="display: initial;" effect="dark" :content="'上傳其他證明文件'+(othIndex+1)" placement="right-end"
                                v-if="checkEditMode()">
                                <el-upload
                                  ref="upload"
                                  action="./WebApi/Tools/UploadV2"
                                  accept=".pdf"
                                  :name="'f' + inputData.documentID + '_7' + othIndex + (info5==null || info5[othIndex]==null? 0: info5[othIndex].length)"
                                  :on-success="handleAvatarSuccess"
                                  :on-remove="handleChangeF5"
                                  :before-upload="onBeforeUploadF5"
                                  v-if="item.status!='R'">
                                  <el-button size="small" type="primary"
                                    @click="fileIndex = 500 + othIndex*10 + (info5==null || info5[othIndex]==null? 0: info5[othIndex].length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                                </el-upload>
                            </el-tooltip> 
                          </td>
                          <!-- <td style="width: 5em; padding: 0.75em; vertical-align: top;"
                              v-if="checkEditMode()">
                            <div v-if="othIndex==0">
                              <el-button style="padding: 0.75em 1em;" type="primary" plain
                                v-if="'99'!=inputData.ideType"
                                @click="removeFile4Item(item, othIndex)">清除</el-button>
                            </div>
                            <div v-else> 
                              <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                    v-if="item.status=='R'">
                                刪除…
                              </span> 
                              <el-tooltip class="item" effect="dark" content="刪除整筆資料" placement="right-start"
                                  v-else>
                                <el-button style="padding: 0.75em 1em;" type="primary" plain
                                @click="delFile5Item(othIndex)">刪除</el-button> 
                              </el-tooltip>
                            </div>
                          </td> -->
                          <td style="width: 5em; padding: 0.75em; vertical-align: top;"
                              v-if="checkEditMode()">                             
                              <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                    v-if="item.status=='R'">
                                刪除…
                              </span> 
                              <el-tooltip class="item" effect="dark" content="刪除整筆資料" placement="right-start"
                                  v-else>
                                <el-button style="padding: 0.75em 1em;" type="primary" plain
                                @click="delFile5Item(othIndex)">刪除</el-button> 
                              </el-tooltip>                            
                          </td>
                        </tr> 
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td class="ncut-base-form-ipt doc-title" style="color:#7C4B00;">
                    <i class="el-icon-document"></i> 書面審查必繳資料：
                  </td>
                  <td class="ncut-base-form-ipt" colspan="2">
                    <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                       class="btn btn-info btn-md"
                       v-if="checkEditMode()"
                       @click="addMajorRow()">
                      <i class="el-icon-circle-plus-outline"></i>新增必繳資料
                    </a>
                  </td>
                </tr>
                <tr>
                  <td class="ncut-base-form-ipt" style="padding: 0.5em;" colspan="3">                
                    <table class="table table-bordered table-striped" style="background:#FFFFFF; width:100%;">
                      <tbody>
                        <tr v-for="(item, maIndex) in inputData.majorInfo" :key="maIndex" :index="'0'+maIndex" :name="'MA'+maIndex">
                          <td style="width:9em;">
                            必繳資料{{maIndex+1}}
                          </td>
                          <td style="width:16em;">
                            <el-autocomplete
                              class="inline-input"
                              style="width: 15.75em;"
                              v-model="item.descr"
                              :fetch-suggestions="queryMajor"
                              placeholder="請輸入必繳資料名稱"
                              @select="item.status=(item.status=='A'?item.status:'M')"
                              :disabled="!checkEditMode()" ></el-autocomplete>
                            <!--<el-input v-model="item.descr" placeholder="請輸入必繳資料名稱" style="width: 10em; display: inline; " maxlength="20"
                                        :disabled="!checkEditMode()||inputData.eMode==1"
                                        @change="item.status=(item.status=='A'?item.status:'M')"></el-input>-->
                          </td>
                          <td style="min-width:25em; margin:0;">
                            <ul style="clear:both" class="response"
                                v-if="item!=null && item.info!=null && item.info.length > 0">
                              <li class="sel-file" 
                                  v-for="(fi,index) in item.info" :key="index" :index="'0'+index" :name="'F5'+index">
                                <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                      v-if="fi.status=='R'">
                                  刪除…
                                </span>
                                <span v-else>
                                  <a :href="'./WebApi/Tools/GetDocument/'+fi.rowId" target="_blank">
                                    <img v-if="fi.img != null" :src="fi.img" style="width: 2em;" />
                                    <img v-if="fi.img == null" src="@/assets/images/disk.png" /> {{fi.name}}{{fi.ext}}
                                  </a>
                                  &nbsp;&nbsp;
                                  <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                                    <el-button icon="el-icon-delete" circle
                                       @click="setModifyFlag(item);setDelFlag(fi);"
                                       v-if="checkEditMode()&&item.status!='R'"></el-button>
                                  </el-tooltip>
                                </span> 
                              </li>
                            </ul>
                            <el-tooltip class="item" style="display: initial;" effect="dark" :content="'上傳必繳資料'+(maIndex+1)" placement="right-end"
                              v-if="checkEditMode()">
                              <el-upload
                                ref="upload"
                                action="./WebApi/Tools/UploadV2"
                                accept=".pdf"
                                :name="'f' + inputData.documentID + '_9' + maIndex + (info6==null || info6[maIndex]==null? 0: info6[maIndex].length)"
                                :on-success="handleAvatarSuccess"
                                :on-remove="handleChangeF6"
                                :before-upload="onBeforeUploadF6"
                                v-if="item.status!='R'">
                                <el-button size="small" type="primary"
                                  @click="fileIndex = 600 + maIndex*10 + (info6==null || info6[maIndex]==null? 0: info6[maIndex].length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                              </el-upload>
                            </el-tooltip>   
                          </td>
                          <td style="width: 5em; padding: 0.75em; vertical-align: top;"
                              v-if="checkEditMode()">
                            <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                  v-if="item.status=='R'">
                              刪除…
                            </span> 
                            <el-tooltip class="item" effect="dark" content="刪除整筆資料" placement="right-start"
                                  v-else>
                              <el-button style="padding: 0.75em 1em;" type="primary" plain
                                @click="delFile6Item(maIndex)">刪除</el-button> 
                            </el-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <!-- <tr>
                  <td class="ncut-base-form-ipt doc-title" style="color:#B25D25;">
                    <i class="el-icon-document"></i> 書面審查選繳資料：
                  </td>
                  <td class="ncut-base-form-ipt" colspan="2">
                        <a href="#" style="text-align: left; font-weight: bold; font-size: 0.9em; "
                            class="btn btn-info btn-md"
                            v-if="checkEditMode()"
                            @click="addMinorRow()">
                            <i class="el-icon-circle-plus-outline"></i>新增選繳資料
                        </a>
                  </td>
                </tr>
                <tr>
                  <td class="ncut-base-form-ipt" style="padding: 0.5em;" colspan="3">                
                    <table class="table table-bordered table-striped" style="background:#FFFFFF; width:100%;">
                      <tbody>
                        <tr v-for="(item, miIndex) in inputData.minorInfo" :key="miIndex" :index="'0'+miIndex" :name="'MI'+miIndex">
                          <td style="width:9em;">
                            選繳資料{{miIndex+1}}
                          </td>
                          <td style="width:20em;">
                            <el-autocomplete
                              class="inline-input"
                              v-model="item.descr"
                              :fetch-suggestions="queryMinor"
                              placeholder="請輸入選繳資料名稱"
                              @select="item.status=(item.status=='A'?item.status:'M')"
                              :disabled="!checkEditMode()||inputData.eMode==1" ></el-autocomplete>
                          </td>
                          <td style="width:25em; margin:0;">
                            <ul style="clear:both" class="response"
                                v-if="item.info!=null && item.info.length > 0">
                              <li class="sel-file" 
                                  v-for="(fi,index) in item.info" :key="index" :index="'0'+index" :name="'F5'+index">
                                <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                      v-if="fi.status=='R'">
                                  刪除…
                                </span>
                                <span v-else>
                                  <a :href="'./WebApi/Tools/GetDocument/'+fi.rowId" target="_blank">
                                    <img v-if="fi.img != null" :src="fi.img" style="width: 2em;" />
                                    <img v-if="fi.img == null" src="@/assets/images/disk.png" /> {{fi.name}}{{fi.ext}}
                                  </a>
                                  &nbsp;&nbsp;
                                  <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                                    <el-button icon="el-icon-delete" circle
                                    @click="setModifyFlag(item);setDelFlag(fi);"
                                    v-if="checkEditMode()&&inputData.eMode!=1&&item.status!='R'"></el-button>
                                  </el-tooltip>
                                </span>
                              </li>
                            </ul>
                            <el-tooltip class="item" style="display: initial;" effect="dark" :content="'上傳選繳資料'+(miIndex+1)" placement="right-end"
                              v-if="checkEditMode()&&inputData.eMode!=1">
                              <el-upload
                                ref="upload"
                                action="./WebApi/Tools/UploadV2"
                                accept=".jpg,.pdf"
                                :name="'f' + inputData.documentID + '_10' + miIndex + (info7==null || info7[miIndex]==null? 0: info7[miIndex].length)"
                                :on-success="handleAvatarSuccess"
                                :on-remove="handleChangeF7"
                                :before-upload="onBeforeUploadF7"
                                v-if="item.status!='R'">
                                <el-button size="small" type="primary"
                                  @click="fileIndex = 700 + miIndex*10 + (info7==null || info7[miIndex]==null? 0: info7[miIndex].length)">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                              </el-upload>  
                            </el-tooltip>
                          </td>
                          <td style="width: 5em; padding: 0.75em; vertical-align: top;"
                              v-if="checkEditMode()&&inputData.eMode!=1">
                            <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                  v-if="item.status=='R'">
                              刪除…
                            </span> 
                            <el-row  v-else>
                              <el-button style="padding: 0.75em 1em;" type="primary" plain
                                @click="delFile7Item(miIndex)">刪除</el-button> 
                            </el-row>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr> -->
                <tr>
                  <td colspan="3">
                    <b>注意提醒：</b>
                    <table class="w-100-input" style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;" rules="all" bgcolor="#FFFFFF">
                      <thead>
                        <tr>
                          <td width="33%" style="font-weight: bold;text-align: center;color: darkred;background: wheat;">書面審查必繳資料 <font size="-1">(請依各系規定上傳，不要遺漏)</font></td>
                          <!-- <td width="33%" style="font-weight: bolder;text-align: center;background: #D6ECF0;">書面審查選繳資料 <font size="-1">(請依各系規定上傳，請儘量提供)</font></td> -->
                          <td width="33%" style="font-weight: bolder;text-align: center;background: #D6ECF0;">同分參酌順序</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="deptMsg!=null">
                          <td style="padding: 0 0.5em;vertical-align: top;background: cornsilk;">
                            <span v-html="deptMsg.major"></span>
                          </td>
                          <!-- <td style="padding: 0 0.5em; vertical-align: top;">
                            <span v-html="deptMsg.minor"></span>
                          </td> -->
                          <td style="padding: 0 0.5em; vertical-align: top;">
                            <span v-html="deptMsg.ratio"></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr> 
                  <td colspan="3" style="background:#f0f5e5;">
                    <div style="display: block; font-size:0.9rem;">
                      <b>
                        檔案格式：
                      </b>
                      <ul style="list-style-type:disc;">
                        <li>請先將上傳檔案放置於桌面。</li>
                        <li>副檔名 .pdf。</li>
                        <li>書審相關檔案大小不得超過10MB，其餘不得超過2MB。</li>
                      </ul>
                    </div>
                  </td>
                </tr>
          </table>
          <br />
          <div class="ncut-base-form-button" style="text-align: center;"
            v-if="(0==inputData.isApproval)">
            <el-button-group>
              <el-button type="primary" @click="prevPage(1)" icon="el-icon-arrow-left">{{$t('message.Back_txt')}}</el-button>
              <el-button type="primary" @click="nextPage(1)">{{$t('message.Next_txt')}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </el-button-group>&nbsp;&nbsp;&nbsp;&nbsp;
            <!-- <el-button type="primary" plain @click="nextPage(1)">下一步</el-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <el-button type="success" @click="keep()" v-if="checkEditMode()">{{$t('message.Keep_txt')}}</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane name="P3" key="3" :disabled="tabsData[3].disabled" >
          <span slot="label"><i :class="tabsData[3].icon"></i>{{tabsData[3].title}}</span>
          <div>
            <p  v-if="!isSafari">
              <pdf scale="page-width" style="width:100%;margin:0.25em auto;border: 1px solid #BBCDC5 !important;"
              :src="sysDoc" 
              v-for="i in numPages"
              :key="i"
              :page="i"
              ></pdf>
            </p>
            <iframe :src="'https://docs.google.com/viewer?url='.concat(setting.serverUrl[0].codeName).concat('/WebApi/Tools/ShowSystemDoc/').concat(sysId).concat('/5').concat('&embedded=true')" frameborder="0" height="500px" width="100%"
              v-else></iframe>
          </div>
          <br />
          <div class="ncut-base-form-button" style="text-align: center;"
            v-if="(0==inputData.isApproval)">
            <el-button-group>
              <el-button type="primary" @click="prevPage(1)" icon="el-icon-arrow-left">{{$t('message.Back_txt')}}</el-button>
              <el-button type="primary" @click="nextPage(1)">我已同意，下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </el-button-group>
            <!-- <el-button type="primary" plain @click="nextPage(1)">我已同意，下一步</el-button> -->
          </div>
        </el-tab-pane>
        <el-tab-pane name="P4" key="4" :disabled="tabsData[4].disabled" >
          <span slot="label"><i :class="tabsData[4].icon"></i>{{tabsData[4].title}}</span>
          <table class="w-100-input" style="background-color: white;border: gray;font-size: 1rem; width:100%;" rules="all"  >
            <tbody style="line-height:3em;">
              <tr>
                <td colspan="16" style="font-size: larger; font-weight: bolder; background:#f8f4ed;">
                  <p v-html="successMsg[1].contText" style="font-size:14px;padding: 0;"
                    v-if="successMsg!=null"></p>
                  <!-- <ol type="1"
                    v-if="checkEditMode()">
                    <li>請再次核對<span style="color:darkred;">基本資料</span>及<span style="color:darkred;">報考資料</span>是否有誤，如資料有誤請返回修正，確認無誤後請按「確認送出」。</li>
                    <li><span style="color:darkred;">點選「確認送出」後，一律不得以任何理由要求修改，請務必審慎檢視確認後再進行送出。</span></li>
                  </ol> -->
                </td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title" style="width:6em;">報名編號</td>
                <td colspan="4" style="padding:0.3em;">{{(null==inputData.regNo||0==inputData.regNo.length?'(送出後由系統產生)':inputData.regNo)}}</td> 
                <td colspan="2" class="ncut-view-title" style="width:6em;">身分證字號</td>
                <td colspan="5" style="padding:0.3em;">{{inputData.idNo}}</td>
                <td colspan="3" rowspan="3" style="text-align: center;">
                  <img v-if="info1!=null" :src="imageUrl" class="avatar"/>
                  <img v-else-if="(imageUrl== null)&& (inputData!=null) && (inputData.info1!=null) && (inputData.info1.length > 0)&&(inputData.info1[0].img != null)&&(inputData.info1[0].status!='R')" 
                    :src="inputData.info1[0].img" class="avatar"/>
                </td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">姓名</td>
                <td colspan="4" style="padding:0.3em;">{{inputData.name}}</td>
                <td colspan="2" class="ncut-view-title">出生年月日</td>
                <td colspan="5" style="padding:0.3em;">{{getCHTDate(inputData.birth, 1)}}</td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">性別</td>
                <td colspan="4" style="padding:0.3em;">{{(inputData.sex==1?'男':'女')}}</td>
                <td colspan="2" class="ncut-view-title">報考身份</td>
                <td colspan="5" style="padding:0.3em;">{{getShowData(3, true)}}</td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">報考資格</td>
                <td colspan="14" style="padding:0.3em;">{{getShowData(4, true)}}</td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">戶籍地址</td>
                <td colspan="6" style="padding:0.3em;">{{getResFullName(1)}}{{inputData.resAddress}}</td>
                <td colspan="2" class="ncut-view-title" style="width:6em;">通訊地址</td>
                <td colspan="6" style="padding:0.3em;">{{getResFullName(2)}}{{inputData.mailAddress}}</td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">聯絡電話(日)</td>
                <td colspan="3" style="padding:0.3em;">{{inputData.phoneNo1}}</td>
                <td colspan="2" class="ncut-view-title">行動電話</td>
                <td colspan="3" style="padding:0.3em;">{{inputData.phoneNo2}}</td>
                <td colspan="2" class="ncut-view-title">E-Mail</td>
                <td colspan="4" style="padding:0.3em;">{{inputData.eMail}}</td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">緊急連絡人</td>
                <td colspan="3" style="padding:0.3em;">{{inputData.emeName}}</td>
                <td colspan="2" class="ncut-view-title">關係</td>
                <td colspan="3" style="padding:0.3em;">{{inputData.emeRelation}}</td>
                <td colspan="2" class="ncut-view-title">聯絡電話</td>
                <td colspan="4" style="padding:0.3em;">{{inputData.emePhone}}</td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">畢肄業學校</td>
                <td colspan="5" style="padding:0.3em;">{{showSchool}}</td>
                <td colspan="2" class="ncut-view-title">科別</td>
                <td colspan="3" style="padding:0.3em;">{{showDept}}</td>
                <td colspan="2" class="ncut-view-title">畢肄業年月</td>
                <td colspan="2" style="padding:0.3em;">{{gradTimeCHT}}</td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">現任服務單位</td>
                <td colspan="5" style="padding:0.3em;">{{inputData.othrInfo.coName}}</td>
                <td colspan="2" class="ncut-view-title">職稱</td>
                <td colspan="3" style="padding:0.3em;">{{inputData.othrInfo.title}}</td>
                <td colspan="2" class="ncut-view-title">服務期間</td>
                <td colspan="2" style="padding:0.3em;">
                  {{getCHTDate(inputData.othrInfo.startData, 1)}}（共 {{(inputData.othrInfo.yy==null? 0:inputData.othrInfo.yy)}} 年 {{(inputData.othrInfo.mm==null? 0: inputData.othrInfo.mm)}} 月）
                </td>
              </tr>
              <tr style="font-size:1.05em;">
                <td colspan="2" class="ncut-view-title">需考場協助</td>
                <td colspan="3" style="padding:0.3em;">{{(inputData.othrInfo.impaFlag?"是":"否")}}</td>
                <td colspan="2" class="ncut-view-title">協助事項</td>
                <td colspan="9" style="padding:0.3em;">
                  {{(inputData.othrInfo.impaFlag?inputData.othrInfo.impaMemo:"無")}}
                  <ul style="clear:both" v-if="(inputData.info8 != null) && (inputData.info8.length > 0)" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg8List" :key="index" :index="'0'+index" :name="'ID'+index">
                      <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                    </li>
                  </ul>
                  <ul style="clear:both" class="response" 
                    v-if="info10!=null && info10.length > 0">
                    <li class="sel-file" 
                      v-for="(fi,f2Index) in info10" :key="f2Index" :index="'0'+f2Index" :name="'F10'+f2Index">
                      <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                        v-if="fi.status=='R'">刪除…</span>
                      <span v-else>{{fi.tempName}}</span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr style="font-size:1.05em;" 
                v-if="((info2 != null) && (info2.length > 0)) || ((inputData.info2 != null) && (inputData.info2.length > 0))">
                <td colspan="2" class="ncut-view-title">身分證正反面影本</td>
                <td colspan="14" style="padding:0.3em;">                  
                  <ul style="clear:both; margin: 0;" class="response">
                    <li class="sel-file" v-for="(f,index) in info2" :key="index" :index="'0'+index" :name="'ID'+index">{{f.tempName}}</li>
                  </ul>
                  <ul style="clear:both; margin: 0;" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg2List" :key="index" :index="'0'+index" :name="'ID'+index">
                      <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr style="font-size:1.05em;" 
                v-if="((info3 != null) && (info3.length > 0)) || ((inputData.info3 != null) && (inputData.info3.length > 0))">
                <td colspan="2" class="ncut-view-title">學歷證明文件</td>
                <td colspan="14" style="padding:0.3em;">                  
                  <ul style="clear:both; margin: 0;" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg3List" :key="index" :index="'0'+index" :name="'ID'+index">
                      <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                    </li>
                  </ul>              
                  <ul style="clear:both; margin: 0;" class="response">
                    <li class="sel-file" v-for="(f,index) in info3" :key="index" :index="'0'+index" :name="'PH'+index">{{f.tempName}}</li>
                  </ul>
                </td>
              </tr>
              <tr style="font-size:1.05em;" 
                v-if="((info8 != null) && (info8.length > 0)) || ((inputData.info6 != null) && (inputData.info6.length > 0))">
                <td colspan="2" class="ncut-view-title">歷年成績單</td>
                <td colspan="14" style="padding:0.3em;">                  
                  <ul style="clear:both; margin: 0;" class="response">
                    <li class="sel-file" v-for="(f,index) in info8" :key="index" :index="'0'+index" :name="'ID'+index">{{f.tempName}}</li>
                  </ul>                 
                  <ul style="clear:both; margin: 0;" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg6List" :key="index" :index="'0'+index" :name="'ID'+index">
                      <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr style="font-size:1.05em;" 
                v-if="(inputData.othersInfo != null) && (inputData.othersInfo.length > 0)">
                <td colspan="2" class="ncut-view-title">其他證明文件</td>
                <td colspan="14" style="padding:0.3em;">   
                    <table class="table table-bordered table-striped" style="background:#FFFFFF; width:100%; margin:0;">
                      <tbody>
                        <tr v-for="(item,othIndex) in inputData.othersInfo" :key="othIndex" :index="'0'+othIndex" :name="'O'+othIndex">
                          <td style="width:9em;">
                            其他證明文件{{othIndex+1}}
                          </td>
                          <td style="width:16em;">{{item.descr}}</td>
                          <td style="min-width:25em; margin:0;">
                            <ul style="clear:both" class="response" 
                              v-if="item.info!=null && item.info.length > 0">
                              <li class="sel-file" 
                                v-for="(fi,f2Index) in item.info" :key="f2Index" :index="'0'+f2Index" :name="'F5'+f2Index">
                                  <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                        v-if="fi.status=='R'">
                                    刪除…
                                  </span>
                                  <span v-else>
                                    <a :href="'./WebApi/Tools/GetDocument/'+fi.rowId" target="_blank">
                                      <img v-if="fi.img != null" :src="fi.img" style="width: 2em;" />
                                      <img v-if="fi.img == null" src="@/assets/images/disk.png" /> {{fi.name}}{{fi.ext}}
                                    </a>
                                  </span>
                              </li>
                            </ul>
                            <ul style="clear:both" class="response" 
                              v-if="info5!=null && info5[othIndex]!=null && info5[othIndex].length > 0">
                              <li class="sel-file" 
                                v-for="(fi,f2Index) in info5[othIndex]" :key="f2Index" :index="'0'+f2Index" :name="'F5'+f2Index">
                                  <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                        v-if="fi.status=='R'">刪除…</span>
                                  <span v-else>{{fi.tempName}}</span>
                              </li>
                            </ul>
                          </td>
                        </tr> 
                      </tbody>
                    </table>
                </td>
              </tr>
              <tr style="font-size:1.05em;" 
                v-if="(inputData.majorInfo != null) && (inputData.majorInfo.length > 0)">
                <td colspan="2" class="ncut-view-title">必繳資料</td>
                <td colspan="14" style="padding:0.3em;">
                  <table class="table table-bordered table-striped" style="background:#FFFFFF; width:100%; margin:0;">
                    <tbody>
                      <tr v-for="(item,maIndex) in inputData.majorInfo" :key="maIndex" :index="'0'+maIndex" :name="'MA'+maIndex">
                        <td style="width:9em;">
                          必繳資料{{maIndex+1}}
                        </td>
                        <td style="width:16em;">{{item.descr}}</td>
                        <td style="min-width:25em; margin:0;">
                          <ul style="clear:both; margin: 0;" class="response" 
                            v-if="item.info!=null && item.info.length > 0">
                            <li class="sel-file" 
                              v-for="(fi,f2Index) in item.info" :key="f2Index" :index="'0'+f2Index" :name="'F5'+f2Index">
                                <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                      v-if="fi.status=='R'">
                                  刪除…
                                </span>
                                <span v-else>
                                  <a :href="'./WebApi/Tools/GetDocument/'+fi.rowId" target="_blank">
                                    <img v-if="fi.img != null" :src="fi.img" style="width: 2em;" />
                                    <img v-if="fi.img == null" src="@/assets/images/disk.png" /> {{fi.name}}{{fi.ext}}
                                  </a>
                                </span>
                            </li>
                          </ul>
                          <ul style="clear:both; margin: 0;" class="response" 
                            v-if="info6!=null && info6[maIndex]!=null && info6[maIndex].length > 0">
                            <li class="sel-file" 
                              v-for="(fi,f2Index) in info6[maIndex]" :key="f2Index" :index="'0'+f2Index" :name="'F5'+f2Index">
                              <span style="font-size: larger; font-weight: bolder; color: #4c1f24;" 
                                v-if="fi.status=='R'">刪除…</span>
                              <span v-else>{{fi.tempName}}</span>
                            </li>
                          </ul>
                        </td>
                      </tr> 
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div class="ncut-base-form-button" style="text-align: center;"
            v-if="(0==inputData.isApproval)">
            <el-button type="primary" @click="prevPage(1)" icon="el-icon-arrow-left">{{$t('message.Back_txt')}}</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button type="success" @click="submit()" v-if="checkEditMode()">{{$t('message.Send_cmd')}}<i class="el-icon-success el-icon--right"/></el-button>
          </div>
          <div 
            v-show="activeName=='P4'">
            <!-- <font style="font-weight:bold; border: 1px solid #2b73af; padding: 0.2em; border-radius: 4px; color: #132c33;">備註</font> -->
            <font style="font-weight:bold; color: #132c33;">備註：</font>
            <div style="padding: 0.5em 0 0;"
              v-html="successMsg[3].contText"
              v-if="successMsg!=null"/>
          </div> 
        </el-tab-pane>
      </el-tabs>
    </div>
    <modal name="selectView"
      @before-open="beforeOpen"
      @before-close="beforeClose">
    </modal>
  </div> 
</template>

<script id="modal-template">
import pdf from 'vue-pdf'
import vOption from '@/components/OptionSelection.vue'

export default {
  name: 'enrollCEE',
  data () {
    return {
      saveFg: 0,
      active: 0,
      activeName: 'P0',
      fileIndex: 0,
      fileData: null,
      deptMsg: null,
      tabsData: [
        { pageId: 0, title: '基本資料設定',     disabled: false,  icon: 'el-icon-edit' }, 
        { pageId: 1, title: '報考資料設定',     disabled: true ,  icon: 'el-icon-edit' },
        { pageId: 2, title: '書面審查文件上傳',  disabled: true,  icon: 'el-icon-upload'},
        { pageId: 3, title: '個資處理告知',     disabled: true ,  icon: 'el-icon-document'},
        { pageId: 4, title: '資料預覽',         disabled: true ,  icon: 'el-icon-view'}
      ],
      inputData: {
        eMode: 1,
        account : '',
        birth : new Date(),
        documentID: 0,
        eEId: 0,
        eMail: '',
        emeName: '',
        emePhone: '',
        emeRelation: '', 
        idNo: '', 
        mailAddress: '', 
        name    : '',
        phoneNo1: '',
        phoneNo2: '', 
        regNo : '', 
        sex : 0,
        othersStr: '',
        stdID : 0,
        qId : 0,
        isLowIncome: 0,
        isApproval: 0,
        othrInfo: {
          coName: '',
          title: '',
          impaFlag: false
        }
      },
      eduQual: false,
      addressFg: false,
      cityItem: null,
      depItem: null,
      idenItem: null,
      qualItem: null,
      schoolItem: null,
      districtItem1: null,
      districtItem2: null,
      successMsg: null,
      idenStr: '',
      fileFormDataName: '',
      dptMsg:'',
      info1: null,
      info2: null,
      info3: null,
      info4: null,
      info5: null,
      info6: null,
      info7: null,
      info8: null,   // 在校成績
      info9: null,   // 修業計畫
      info10: null,  // 身心障礙證明
      imageUrl: null,
      header:{
        'my-header': 'my-header-value'
      },
      isSafari: false,
      numPages: 0,
      LowIncomeOpt: [{
          value: 0,
          label: '無'
        }, {
          value: 1,
          label: '中低收入戶'
        }, {
          value: 2,
          label: '低收入戶'
        }]
      // fileList: []
    }
  },
  components: {
    pdf,
    vOption
  },
  computed: {
    labelColor () {
      return (!this.eduQual? '#CC3300': '#2c3e50');
    },
    filterImg2List: function () {
      if (null != this.inputData.info2) {
        var shoppingList = this.inputData.info2;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    filterImg3List: function () {
      if (null != this.inputData.info3) {
        var shoppingList = this.inputData.info3;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    filterImg6List: function () {
      if (null != this.inputData.info6) {
        var shoppingList = this.inputData.info6;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    filterImg7List: function () {
      if (null != this.inputData.info7) {
        var shoppingList = this.inputData.info7;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    filterImg4List: function () {
      if ((null!=this.inputData.othersInfo) && (0 < this.inputData.othersInfo.length) && (null != this.inputData.othersInfo[0].info)) {
        var shoppingList = this.inputData.othersInfo[0].info;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    filterImg8List: function () {
      if (null != this.inputData.info8) {
        var shoppingList = this.inputData.info8;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    sysId () {
      return this.$store.getters.getSysId
    },
    sysDoc () {
      return pdf.createLoadingTask('./WebApi/Tools/ShowSystemDoc/'.concat(this.$store.getters.getSysId).concat('/5'));
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    },
    showSchool () {
      return this.getShowData(1, true);
    },
    showDept () {
      return this.getShowData(2, true);
    },    
    qualStr () {
      var ret = '';
      var found = false;
      if ((null != this.qualItem) && (this.inputData.qId>0)) {          
        var len = this.qualItem.length;
        for (var i = 0; i < len&&!found; i++) {
          if (this.inputData.qId == this.qualItem[i].qId) {
            var dLen = this.qualItem[i].docSet.length;
            for (var j = 0; j < dLen; j++) {
              if (!this.isEmpty(this.qualItem[i].docSet[j])) {                  
                if (j > 0) {
                  ret = ret.concat('、');
                }                
                ret = ret.concat(this.qualItem[i].docSet[j]);
              }
            }
            found = true;
            this.eduQual = this.qualItem[i].eduQual;
            break;
          }
        }
      }
      return ret;
    },
    gradTimeCHT () {
      var dateStr = ''; 
      if (!this.isNull(this.inputData.gradTime)) {
        if (typeof this.inputData.gradTime == "string") {
          this.inputData.gradTime = new Date(this.inputData.gradTime);
        } else {
          this.inputData.gradTime = this.inputData.gradTime;
        }
        dateStr = "民國" + (this.inputData.gradTime.getFullYear() - 1911) + "年" + (this.inputData.gradTime.getMonth() + 1) + "月";
      }

      return dateStr;
    },
    fileName() {
      var name = '';
      if (this.inputData != null && this.fileIndex>0) {
          
        var file = (this.fileIndex==0?[]:this.info[this.fileIndex-1])
        var subName = (this.inputData!=null? 'f'+this.inputData.documentID+'_'+this.fileIndex:'');
      
        name =this.changeFileName(file.name, subName);
      }
      return name;
    },
    idenName () { // 報考身份
      var nameStr = '';
      
      if ((this.inputData.ideID != null) && (this.idenItem != null)) {
        for (var j = 0; (j < this.idenItem.length) && (nameStr == '') ; j++) {
          if (this.inputData.ideID == this.idenItem[j].idenID) {
            nameStr = this.idenItem[j].idenNo + " " + this.idenItem[j].name;
          }
        }
      }
      return nameStr;
    }
  },
  methods: {
    getFileName (fn) {
        var ret = fn;
        var nameStr = fn.trim().split('\\');
        var fLen = nameStr.length;
        if (1 < fLen) {
            ret = nameStr[fLen - 1];
        }
        return ret;
    },
    beforeOpen (event) {
      console.log("beforeOpen" + event);
    },
    beforeClose (event) {
      console.log("beforeClose" + event);
    },
    queryMajor(queryString, cb) {
      var items = [{ "value": '服務履歷表'},{ "value": '修業計畫書'},{ "value": '推薦函'},{ "value": '未來研究計畫'}];
      var results = queryString ? items.filter(this.createFilter(queryString)) : items;
      cb(results);
    },
    queryMinor(queryString, cb) {
      var items = [{ "value": '自傳'},{ "value":'技術證照'},{ "value":'專利'},{ "value":'全民英檢證書'},{ "value":'專題研發成果'},{ "value":'獲奬證明'},{ "value":'未來研究計畫'},{ "value":'論文'}];
      var results = queryString ? items.filter(this.createFilter(queryString)) : items;
      cb(results);
    },
    createFilter(queryString) {
      return (items) => {
        return (items.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    setDelFlag(item) {
      item.status='R';
    },
    setModifyFlag(item) {
      if (item.status != 'A') {
        item.status = 'M';
      }
    },
    addDocRow() {
      var elements = { index: (null == this.inputData.othersInfo ? 1 : this.inputData.othersInfo.length + 1), descr: '', info: null, status: 'A', type: 7 };

      if (this.inputData.othersInfo == null) {
        var arry1 = [elements];

        this.inputData.othersInfo = arry1;
      }
      else {
        this.inputData.othersInfo.push(elements);
      }
    },
    addMajorRow() {
      var elements = { index: (null == this.inputData.majorInfo ? 1 : this.inputData.majorInfo.length + 1), descr: '', info: null, status: 'A', type: 9 };

      if (this.inputData.majorInfo == null) {
        var arry1 = [elements];

        this.inputData.majorInfo = arry1;
      }
      else {
        this.inputData.majorInfo.push(elements);
      }
    },
    addMinorRow() {
      var elements = { index: (null == this.inputData.minorInfo ? 1 : this.inputData.minorInfo.length + 1), descr: '', info: null, status: 'A', type: 10 };

      if (this.inputData.minorInfo == null) {
        var arry1 = [elements];

        this.inputData.minorInfo = arry1;
      }
      else {
        this.inputData.minorInfo.push(elements);
      }
    },
    changeFileName(fn, subNm) {
      var ret = fn;
      var nameStr = fn.trim().split('.');
      var fLen = nameStr.length;
      if (1 < fLen) {
        ret = subNm + "." + nameStr[fLen - 1];
      }
      return ret;
    },
    getShowData (idx, flag) {
      var ret = '';
      if (null != this.inputData) {
        switch (idx) { 
          case 1: // 畢肄業學校
                  this.getGradSchoolItem();
                  if ((null != this.schoolItem) && (null != this.inputData.schoolID) && (0 < this.inputData.schoolID)) {
                    for (var j = 0; (j < this.schoolItem.length) ; j++) {
                      if (this.inputData.schoolID == this.schoolItem[j].optionNo) {
                        var tObj = this.schoolItem[j];
                        if (flag) {
                          ret = tObj.codeNo + " " + tObj.codeName; 
                        } else  {
                          ret = tObj.codeName; 
                        }
                        break;
                      }
                    }
                  }
                  if (0 == ret.length) {
                    ret = '請選擇畢肄業學校';
                  }
                  break;
          case 2: // 科別
                  this.getGradDeptItem();
                  if ((null != this.depItem) && (null != this.inputData.gDeptID) && (0 < this.inputData.gDeptID)) {
                    for (var j = 0; (j < this.depItem.length) ; j++) {
                      if (this.inputData.gDeptID == this.depItem[j].optionNo) {
                        var tObj = this.depItem[j];  
                        if (flag) {
                          ret = tObj.codeNo + " " + tObj.codeName; 
                        } else  {
                          ret = tObj.codeName; 
                        }
                        break;
                      }
                    } 
                  }
                  if (0 == ret.length) {
                    ret = '請選擇畢肄業科別';
                  }
                  break;
          case 3: // 報考身份
                  if ((this.inputData.ideID != null) && (this.idenItem != null)) {
                    for (var j = 0; (j < this.idenItem.length) && (ret == '') ; j++) {
                      if (this.inputData.ideID == this.idenItem[j].idenID) {
                        ret = this.idenItem[j].idenNo + " " + this.idenItem[j].name;
                      }
                    }
                  }
                  break;
          case 4: // 報考資格
                  if ((this.inputData.qId != null) && (this.qualItem != null)) {
                    for (var j = 0; (j < this.qualItem.length) && (ret == '') ; j++) {
                      if (this.inputData.qId == this.qualItem[j].qId) {
                        ret = this.qualItem[j].name;
                      }
                    }
                  }
                  break;
        }
      }

      return ret;
    },  
    showSchoolModal() {
      this.$modal.show(vOption, {
        title: '畢肄業學校選擇',
        mode: 1,
        eId: this.setting.enrollID[0].codeName,
        sysId: this.sysId
      }, {
        height: 'auto'
      }, {
        'closed': this.modalSchoolClose,
        'before-open': this.beforeOpen,
        'before-close': this.beforeClose
      })
    },  
    showDeptModal() {
      this.$modal.show(vOption, {
        title: '畢肄業系科選擇',
        mode: 2,
        eId: this.setting.enrollID[0].codeName,
        sysId: this.sysId
      }, {
        height: 'auto'
      }, {
        'closed': this.modalDeptClose,
        'before-open': this.beforeOpen,
        'before-close': this.beforeClose
      })
    },
    modalSchoolClose (event) {
      if (this.$store.getters.getOptionFlag) {
        this.inputData.schoolID = this.$store.getters.getOptionId;
        this.inputData.othrInfo.schoolExtra = this.getShowData(1, false);
      }
    },
    modalDeptClose (event) {
      if (this.$store.getters.getOptionFlag) {        
        this.inputData.gDeptID = this.$store.getters.getOptionId;
        this.inputData.othrInfo.deptExtra = this.getShowData(2, false);
      }
    },
    checkEditMode() {
      if (null != this.inputData) {
        return (0 == this.inputData.isApproval);
      }
    },
    changePage(tab, event) {
      var page = parseInt(tab.index);
      if (page < this.tabsData.length) {
        this.checkTabDataById(page);
        // this.changeCurPage(page);
        // this.resetDisabled(page);
      }
    },
    getCHTDate(data, format) {
      var dateStr = '';
      var date = null;

      if (data != null) {
        if (typeof data == "string") {
          date = new Date(data);
        } else {
          date = data;
        }

        switch (format) {
          case 1:
                  dateStr = "民國"+(date.getFullYear() - 1911)+"年"+(date.getMonth() + 1)+"月"+date.getDate()+"日";
                  break;
          default:
                  dateStr = "民國"+(date.getFullYear() - 1911)+"年"+(date.getMonth() + 1)+"月"+date.getDate()+"日 "+date.getHours()+"："+date.getMinutes();
                  break;
        } 
      }

      return dateStr;
    },
    getIdenItem () {
      if (this.idenItem == null) {
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetIdenDesc/" + this.setting.enrollID[0].codeName)
            .then(function(response) {
              if (null != response.data) {
                vm.idenItem = response.data;
                if (1 == vm.idenItem.length) {         
                  if (null == vm.inputData.ideID || 0== vm.inputData.ideID) {               
                    vm.inputData.ideID = vm.idenItem[0].idenID;
                  }
                }

                if (0 < vm.inputData.ideID) {
                  vm.setIdenMsg();
                } else {
                  vm.idenStr = '';
                }
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    getQualItem() {
      if (this.qualItem == null) { 
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetQualList/".concat(this.setting.enrollID[0].codeName).concat("/").concat(this.inputData.groupID).concat("/").concat(this.inputData.deptID))
            .then(function(response) {
              if (null != response.data) {
                vm.qualItem = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    getGradSchoolItem() {
      if (this.schoolItem == null) { 
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetGradSchList/" + this.sysId)
            .then(function(response) {
              if (null != response.data) {
                vm.schoolItem = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    getGradDeptItem () {
      if (this.depItem == null) {
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetGradDeptList/" + this.sysId)
            .then(function(response) {
                if (null != response.data) {
                  vm.depItem = response.data;
                }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    getCityItem() {
      if (this.cityItem == null) { 
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetZipItem/00")
            .then(function(response) {
              if (null != response.data) {
                vm.cityItem = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    getResDistrictItem(idx) {
      var cityName = this.inputData.resCity + '';

      if ((null == this.districtItem1) && (cityName != null) && (cityName != undefined) && (cityName.length > 0)) {
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetZipItem/"+cityName)
            .then(function(response) {
              if (null != response.data) {
                vm.districtItem1 = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    getMailDistrictItem(idx) {
      var cityName = this.inputData.mailCity + '';

      if ((null == this.districtItem2) && (cityName != null) && (cityName != undefined) && (cityName.length > 0)) {
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetZipItem/"+cityName)
            .then(function(response) {
              if (null != response.data) {
                vm.districtItem2 = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    copyAddress() {
      if (this.addressFg && (null != this.inputData)) {
        this.inputData.mailCity = this.inputData.resCity;
        this.inputData.mailDistrict = this.inputData.resDistrict;
        this.inputData.mailAddress = this.inputData.resAddress;
        this.districtItem2 = null;
        this.getMailDistrictItem();
      }
    },
    showSuccessMsg() {
      let vm = this;
      this.$http.get("./WebApi/Setting/GetSuccessMsg/".concat(this.$store.getters.getSysId))
                .then(function(response) {
                  if (null != response.data) {
                    vm.successMsg = response.data;
                    //vm.saveFg = 1;
                  }
                })
                .catch(function (error) {
                  vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起,網路連線失敗</strong>',
                                    offset: 150
                                  });
                });
    },
    isEmpty(data) {
      return ((data != null) && (data != undefined) && (data.length > 0) ? false : true);
    },
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    isNullOrEmpty(str) {
      return  (!str || (str == "null")? true: false);
    },
    isNullOrWhiteSpace(str) {
      return  (!str || (str == "null") || (str.trim() == "")? true: false);
    },
    isSuccess(str) {
      return ((str == "true") || (str == "True") || (str == true) ? true : false);
    },
    resetDisabled(idx) {
      if (this.checkEditMode()) {          
        var len = this.tabsData.length;
        var curIdx = idx+1;
        if (len > curIdx) {        
          for (var i = curIdx; i < len; i++) {
            this.tabsData[i].disabled = true;
          }
        }
      }
    },
    checkFileDe(data){
      var count=0;
      if((data != null) && (data != undefined) && (data.length > 0)){                 
        for (var i = 0; i < data.length; i++) {
          if((data[i].status != 'R') && (data[i].status != 'D')){
            count=1;
          }            
        }        
      } 
      if(count>0){
        return false;
      } else {
        return true;
      }
    },
    checkTab1Data() {
      var msg = '';

      if (this.isEmpty(this.inputData.name)) {
        msg = '輸入姓名';
      } else if (this.isEmpty(this.inputData.phoneNo1)) {
        msg = '輸入聯絡電話(日)';
      } else if (this.isEmpty(this.inputData.phoneNo2)) {
        msg = '輸入手機號碼';
      } else if (0 == this.inputData.sex) {
        msg = '輸入性別';
      } else if (this.isEmpty(this.inputData.eMail)) {
        msg = '輸入E-mail';
      } else if (this.isEmpty(this.inputData.emeName)) {
        msg = '輸入緊急連絡人姓名';
      } else if (this.isEmpty(this.inputData.emeRelation)) {
        msg = '輸入緊急連絡人關係';
      } else if (this.isEmpty(this.inputData.emePhone)) {
        msg = '輸入緊急連絡人聯絡電話';
      } else if (this.isNull(this.inputData.birth)) {
        msg = '輸入出生年月日';
      } else if (this.isNull(this.inputData.resCity) || (0 == this.inputData.resCity) || this.isNull(this.inputData.resDistrict) || (0 == this.inputData.resDistrict) || this.isEmpty(this.inputData.resAddress)) {
        msg = '輸入戶籍地址';
      } else if (this.isNull(this.inputData.mailCity) || (0 == this.inputData.mailCity) || this.isNull(this.inputData.mailDistrict) || (0 == this.inputData.mailDistrict) || this.isEmpty(this.inputData.mailAddress)) {
        msg = '輸入通訊地址';
      } else if (((null == this.info1) || (0 == this.info1.length)) && (this.inputData.info1 == null)) {
        msg = '上傳照片';
      } else if (((null == this.info2) || (0 == this.info2.length)) && ((this.inputData.info2 == null) || this.checkFileDe(this.inputData.info2))) {
        msg = '上傳身分證影本';
      //} else {
      //  this.tabsData[1].disabled = false;
      }
      if (msg.length == 0) {
        this.tabsData[1].disabled = false;
      } else {
        this.resetDisabled(0);
      }

      return msg;
    },
    checkTab2Data() { 
      var msg = '';

      if (this.isNull(this.inputData.ideID) || (0 == this.inputData.ideID)) {
        msg = '輸入報考身份';
      } else if (this.isNull(this.inputData.qId) || (0 == this.inputData.qId)) {
        msg = '輸入報考資格';
      } else if (this.isNull(this.inputData.schoolID) || (0 == this.inputData.schoolID)) {
        msg = '輸入畢肄業學校';
      } else if (this.isNullOrEmpty(this.inputData.othrInfo.schoolExtra)) {
        msg = '輸入畢肄業學校';
      } else if (this.isNull(this.inputData.gDeptID) || (0 == this.inputData.gDeptID)) {
        msg = '輸入畢肄業科別';
      } else if (this.isNullOrEmpty(this.inputData.othrInfo.deptExtra)) {
        msg = '輸入畢肄業科別';
      } else if (this.isNull(this.inputData.gradTime)) {
        msg = '輸入畢肄業年月';
      } else if (this.isEmpty(this.inputData.othrInfo.coName)) {
        msg = '輸入服務單位';
      } else if (this.isEmpty(this.inputData.othrInfo.title)) {
        msg = '輸入職稱';
      } else if (this.isNull(this.inputData.othrInfo.startData)) {
        msg = '輸入現任公司服務期間';
      } else if ((this.isNull(this.inputData.othrInfo.yy) || (this.inputData.othrInfo.yy == 0)) && (this.isNull(this.inputData.othrInfo.mm) || (this.inputData.othrInfo.mm == 0))) {
        msg = '輸入現任公司服務年月';
      } else if (((null == this.info3) || (0 == this.info3.length)) && ((this.inputData.info3 == null) || this.checkFileDe(this.inputData.info3))) {
        msg = '上傳學歷證明';
      } else if (!this.eduQual && ((null == this.info8) || (0 == this.info8.length)) && ((this.inputData.info6 == null) || this.checkFileDe(this.inputData.info6))) {
        msg = '上傳歷年成績單';
      } else if (((null == this.info9) || (0 == this.info9.length)) && ((this.inputData.info7 == null) || this.checkFileDe(this.inputData.info7))) {
        msg = '上傳在職證明';
      } else if (this.inputData.othrInfo.impaFlag && 
                  ((null == this.info10) || (0 == this.info10.length)) && ((this.inputData.info8 == null) || this.checkFileDe(this.inputData.info8))) {
        msg = '上傳申請表及身心障礙證明';
      }
      if (msg.length == 0) {
        this.tabsData[2].disabled = false;
      } else {
        this.resetDisabled(1);
      }

      return msg;
    },
    checkTab3Data() {
      var msg = '';

      if (('99' != this.inputData.ideType) && this.checkFileList(0, true)) {
        msg = '輸入特殊身分證明文件';
      } else if (((null == this.info9) || (0 == this.info9.length)) && ((this.inputData.info7 == null) || this.checkFileDe(this.inputData.info7))) {
        msg = '上傳修業計畫';
      } else if (1 < this.inputData.othersInfo.length) {
        for (var i = 1; i < this.inputData.othersInfo.length; i++) {
          if ('R' != this.inputData.othersInfo[i].status) {
            if (this.isNullOrEmpty(this.inputData.othersInfo[i].descr)) {
              msg = '輸入其它證明文件名稱';
            } else if (this.checkFileList(i, true)) {
              msg = '上傳其它證明文件';
            }
          }
        }
      }
       
      if (msg.length == 0) {        
        if (this.isNull(this.inputData.majorInfo) || (0 == this.inputData.majorInfo.length)) {
          msg = '上傳必繳資料';
        } else {
          for (var i = 0; i < this.inputData.majorInfo.length; i++) {
            if ('R' != this.inputData.majorInfo[i].status) {
              if (this.isNullOrEmpty(this.inputData.majorInfo[i].descr)) {
                msg = '輸入必繳資料名稱';
              } else if (this.checkMajorList(i, true)) {
                msg = '上傳必繳資料';
              }
            }
          }
        }
      }

      if (msg.length == 0 && (0 < this.inputData.minorInfo.length)) {
        for (var i = 0; i < this.inputData.minorInfo.length; i++) {
          if ('R' != this.inputData.minorInfo[i].status) {
            if (this.isNullOrEmpty(this.inputData.minorInfo[i].descr)) {
              msg = '輸入選繳資料名稱';
            } else if (this.checkMinorList(i, true)) {
              msg = '上傳選繳資料';
            }
          }
        }
      }

      if (msg.length == 0) {
        this.tabsData[3].disabled = false;
      } else {
        this.resetDisabled(2);
      }
      return msg;
    },
    checkTab4Data() {
      var msg = '';

      this.tabsData[4].disabled = false;

      return msg;
    },
    checkTabData(){
      return this.checkTabDataById(this.tabsData.length);
    },
    checkTabDataById(id){
      var ret = true;

      for (var i = 0; i < id; i++) {
        ret = this.checkRequiredField(i);

        if (!ret && (this.active != i)) {
          this.getPageUrl(i);
        }
      }
      if (ret && (id < this.tabsData.length)) {
        this.getPageUrl(id);
      }

      return ret;
    },
    checkRequiredField(tabIdx) {
      var ret = false;
      var msg = '';

      switch (tabIdx) {
        case 0:  // 基本資料設定
                msg = this.checkTab1Data();
                break;
        case 1: // 報考資料設定
                this.dptMsg = '';
                msg = this.checkTab2Data();
                break;
        case 2: // 文件上傳
                msg = this.checkTab3Data();
                break;
        case 3: // 個資處理告知
                msg = this.checkTab4Data();
                break;
      }

      if (msg.length > 0) {
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,請<i style="background:yellow;">'+msg+'</i>!</strong>',
                            offset: 150
                          });
      } else {
        ret = true;
      }

      return ret;
    },    
    getDeptMsg() {
      if (null == this.deptMsg) {
        let vm = this
        this.$http
            .get("./WebApi/Apply/GetDeptDocInfo/" + this.inputData.groupID + "/" + this.inputData.deptID)
            .then(function(response) {
              if (!vm.isNull(response.data)) {
                vm.deptMsg = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗'+error+'</strong>',
                                offset: 150
                              });
            });
      } 
    },
    switchPage(pageId) {
      for (var i = 0; i < this.tabsData.length; i++) {
        if (i == pageId) {
          //this.activeName = 'P' + i;
          this.switchPageFunc(i);
          break;
        }
      }
    },
    changeCurPage(pageId) {
      if (!pageId || (pageId < this.active) || (this.checkRequiredField(this.active) == true)) {
        // 畫面切換
        this.getPageUrl(pageId);
      } else {
        this.switchPage(this.active);
      }
    },
    getPageUrl(index) {
      if (this.tabsData[index].disabled == false) {
        this.setPageData(index);
      } else {
        if (this.checkTabData()) {
          this.setPageData(index);
        }
      }
    },
    prevPage() {
      if (this.active>0) {
        var page = this.active - 1;
        if (page < this.tabsData.length) {
          this.changeCurPage(page);    
          //this.resetDisabled(page);
        }
      }
    },
    nextPage() {
      var page = this.active + 1;
      if (page < this.tabsData.length) {
        this.changeCurPage(page);
      }
    },
    switchPageFunc(pageId) {
      // 畫面切換
      this.active = pageId;
      this.activeName = 'P' + pageId;
    },
    getInputData(type) {
      let vm = this;
      this.$http
          .get("./WebApi/Apply/GetInputDataCCE/"+this.user.dId)
          .then(function(response) {
                if (null != response.data) {
                    vm.inputData = response.data;
                    if (null == vm.inputData.sex || 0== vm.inputData.sex) {
                        vm.inputData.sex = (vm.inputData.idNo.substr(1, 1) == '1' ? 1 : 2);
                    }
                    
                    if (null == vm.inputData.ideID || 0== vm.inputData.ideID) {
                      if ((null != vm.idenItem) && (1 == vm.idenItem.length)) {                        
                        vm.inputData.ideID = vm.idenItem[0].idenID;
                      }
                    }
                    
                    if ((0 < vm.inputData.schoolID) && (vm.isNullOrEmpty(vm.inputData.othrInfo.schoolExtra))) {
                      vm.inputData.othrInfo.schoolExtra = vm.getShowData(1, false);
                    }

                    if ((0 < vm.inputData.gDeptID) && (vm.isNullOrEmpty(vm.inputData.othrInfo.deptExtra))) {
                      vm.inputData.othrInfo.deptExtra = vm.getShowData(2, false);
                    }
                    if (1 == type) {
                      let msg = '';  
                      var ret = true;
                      for (var i = 0; i < vm.tabsData.length && ret; i++) {
                        switch (i) {
                          case 0:  // 基本資料設定
                                  msg = vm.checkTab1Data();
                                  break;
                          case 1:  // 報考資料設定
                                  msg = vm.checkTab2Data();
                                  break;
                          case 2: // 上傳文件
                                  msg = vm.checkTab3Data();
                                  break;
                          case 3: // 個資安全
                                  msg = vm.checkTab4Data();
                                  break;
                        }             
                        ret = (msg.length == 0); 
                      } 

                      vm.changeCurPage(0);
                    } 
                }
              })
              .catch(function (error) {
                vm.$notify.error({
                                  title: vm.$t('message.Error_txt'),
                                  dangerouslyUseHTMLString: true,
                                  message: '<strong>對不起,網路連線失敗</strong>',
                                  offset: 150
                                });
          });
    },
    setPageData(index) {
      switch (index) {
        case 0:  // 基本資料設定
                this.getCityItem();
                if ((null != this.inputData.resCity) && (0 < this.inputData.resCity)) {
                  this.getResDistrictItem();
                }
                if ((null != this.inputData.mailCity) && (0 < this.inputData.mailCity)) {
                  this.getMailDistrictItem();
                }
                break;
        case 1: // 報考資料設定  
                this.getIdenItem();
                this.getQualItem();
                this.getGradSchoolItem();
                this.getGradDeptItem();
                break;
        case 2: // 其他證明文件上傳 
                this.getIdenItem();
                this.getDeptMsg();
                break;
        case 3: // 個資處理告知
                // this.getTab4Doc();
                break;
        case 4: // 資料預覽  
                this.getGradSchoolItem();
                this.getGradDeptItem();
                this.getIdenItem();
                this.getQualItem();
                break;
      }
      this.switchPageFunc(index);
    },
    setIdenMsg() {
      var len = this.idenItem.length;
      for (var i = 0; i < len; i++) {
        if (this.inputData.ideID == this.idenItem[i].idenID) {
          this.idenStr = this.idenItem[i].idenDesc;
          this.inputData.ideType = this.idenItem[i].idenNo;
        }
      }
    },
    getResFullName(type) {
      var nameStr = '';
      if (!this.isNull(this.inputData)) {
        var data = '';
        var lst = [];
        if (type == 1) {
          data = this.inputData.resDistrict;
          lst = this.districtItem1;
        } else if (type == 2) {
          data = this.inputData.mailDistrict;
          lst = this.districtItem2;          
        }
        if (!this.isNull(data)) {
          var disNo = data;
          if (typeof disNo == "string") {
            disNo = parseInt(disNo);
          }
          if ((null != lst) && (null != disNo) && (0 < disNo)) {
            for (var j = 0; (j < lst.length) && (nameStr == '') ; j++) {
              var zipNo = lst[j].zipNo;
              if (typeof zipNo == "string") {
                zipNo = parseInt(zipNo);
              }
              if (disNo == zipNo) {
                nameStr = lst[j].fullName;
                break;
              }
            }
          }
        }
      }
      return nameStr;
    },
    handleChangeF2(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info2) {          
        var len = this.info2.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info2[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info2.splice(idx,1);
        }
      }
    },
    handleChangeF3(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info3) {          
        var len = this.info3.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info3[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info3.splice(idx,1);
        }
      }
    },
    handleChangeF4(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info4) {          
        var len = this.info4.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info4[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info4.splice(idx,1);
        }
      }
    },
    handleChangeF5(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info5) {
        var mtLen = this.info5.length;
        var mtIdx = -1;
        var dtIdx = -1;
                
        for (var i = 0; i < mtLen&&mtIdx<0; i++) {
          var dtLen = this.info5[i].length;
          for (var j = 0; j < dtLen&&dtIdx<0; j++) {
            if (this.info5[i][j].tempName == file.name) {
              mtIdx = i;
              dtIdx = j;
            }
          }
        }
        if ((-1 < mtIdx) && (-1 < dtIdx)) {
          this.info5[mtIdx].splice(dtIdx,1);
        }
      }
    },
    handleChangeF6(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info6) {
        var mtLen = this.info6.length;
        var mtIdx = -1;
        var dtIdx = -1;
                
        for (var i = 0; i < mtLen&&mtIdx<0; i++) {
          var dtLen = this.info6[i].length;
          for (var j = 0; j < dtLen&&dtIdx<0; j++) {
            if (this.info6[i][j].tempName == file.name) {
              mtIdx = i;
              dtIdx = j;
            }
          }
        }
        if ((-1 < mtIdx) && (-1 < dtIdx)) {
          this.info6[mtIdx].splice(dtIdx,1);
        }
      }
    },
    handleChangeF7(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info7) {
        var mtLen = this.info7.length;
        var mtIdx = -1;
        var dtIdx = -1;
                
        for (var i = 0; i < mtLen&&mtIdx<0; i++) {
          var dtLen = this.info7[i].length;
          for (var j = 0; j < dtLen&&dtIdx<0; j++) {
            if (this.info7[i][j].tempName == file.name) {
              mtIdx = i;
              dtIdx = j;
            }
          }
        }
        if ((-1 < mtIdx) && (-1 < dtIdx)) {
          this.info7[mtIdx].splice(dtIdx,1);
        }
      }
    },
    handleChangeF8(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info8) {
        var len = this.info8.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info8[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info8.splice(idx,1);
        }
      }
    },
    handleChangeF9(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info9) {
        var len = this.info9.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info9[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info9.splice(idx,1);
        }
      }
    },
    handleChangeF10(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info10) {
        var len = this.info10.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info10[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info10.splice(idx,1);
        }
      }
    },
    onBeforeUploadF1(file)
    {
      this.fileIndex = 1;
      return this.onBeforeUpload(file);      
    },
    onBeforeUploadF2(file)
    {
      this.fileIndex = 8;
      return this.onBeforeUpload(file);      
    },
    onBeforeUploadF3(file)
    {
      this.fileIndex = 2;
      return this.onBeforeUpload(file);      
    },
    onBeforeUploadF4(file)
    {
      this.fileIndex = 5;
      return this.onBeforeUpload(file);      
    },
    onBeforeUploadF5(file)
    {
      //this.fileIndex = 5;
      return this.onBeforeUpload(file);      
    },
    onBeforeUploadF6(file)
    {
      //this.fileIndex = 6;
      return this.onBeforeUpload10M(file);      
    },
    onBeforeUploadF7(file)
    {
      //this.fileIndex = 7;
      return this.onBeforeUpload10M(file);      
    },
    onBeforeUploadF8(file)
    {
      this.fileIndex = 3;
      return this.onBeforeUpload(file);
    },
    onBeforeUploadF9(file)
    {
      this.fileIndex = 9;
      return this.onBeforeUpload(file);
    },
    onBeforeUploadF10(file)
    {
      this.fileIndex = 10;
      return this.onBeforeUpload(file);
    },
    onBeforeUpload(file)
    {
      this.fileData = file;
      //this.fileFormDataName = this.changeFileName(file.name, "f" + this.inputData.documentID + "_" + this.fileIndex);
      //var imgLst = (1 == this.fileIndex ? ['image/jpeg'] : ['image/jpeg', 'application/pdf']);
      var imgLst = ['image/jpeg'];
      if(1 == this.fileIndex){
        imgLst = ['image/jpeg'];
      }else if(2 == this.fileIndex){
        imgLst = ['application/pdf'];
      }else if(8 == this.fileIndex){
        imgLst = ['image/jpeg', 'application/pdf'];
      }else {
        imgLst = ['application/pdf'];
      }
      var isIMAGE = true;
      
      const isLt2M = file.size / 1024 / 1024 < 2;
      if ((0 < imgLst.length) && (0 > imgLst.indexOf(file.type))) {
        var msg = "檔案格式不支援 (檔案限制為 ";
        for (var i = 0; i < imgLst.length; i++) {
          msg += ".".concat(imgLst[i]);
        }
        msg += ")!";
        isIMAGE = false;
        //this.$message.error(msg);
        this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              message: msg,
                              offset: 150
                          });
      }
      if (!isLt2M) {
        //this.$message.error('檔案大小請勿超過 4MB!');
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            message: '檔案大小請勿超過 2MB!',
                            offset: 150
                          });
      }
      
      return (isIMAGE && isLt2M);      
    },
    onBeforeUpload10M(file)
    {
      this.fileData = file;
      //this.fileFormDataName = this.changeFileName(file.name, "f" + this.inputData.documentID + "_" + this.fileIndex);
      //var imgLst = (1 == this.fileIndex ? ['image/jpeg'] : ['image/jpeg', 'application/pdf']);
      var imgLst = ['application/pdf'];
      var isIMAGE = true;
      
      const isLt10M = file.size / 1024 / 1024 < 10;
      if ((0 < imgLst.length) && (0 > imgLst.indexOf(file.type))) {
        var msg = "檔案格式不支援 (檔案限制為 ";
        for (var i = 0; i < imgLst.length; i++) {
          msg += ".".concat(imgLst[i]);
        }
        msg += ")!";
        isIMAGE = false;
        //this.$message.error(msg);
        this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              message: msg,
                              offset: 150
                          });
      }
      if (!isLt10M) {
        //this.$message.error('檔案大小請勿超過 4MB!');
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            message: '檔案大小請勿超過 10MB!',
                            offset: 150
                          });
      }
      
      return (isIMAGE && isLt10M);      
    },
    generateThumb(file) {
      if (file != null) {
        let vm = this;
        var res = file.name.split("\\");
        var retLen = res.length;
        var name = res[retLen - 1]; 
        var fnName = name.split(".");
        this.$http.get("./WebApi/Tools/GetImageV2/f".concat(this.inputData.documentID).concat("_").concat(this.fileIndex))
                  .then((response) => {
                        if (!this.isNull(response.data)) {
                            vm.imageUrl = response.data;
                        }
                  });
      }
    },
    handleAvatarSuccess(res, file) {
      var nmObj = file.response[0].name.trim().split('\\');
      var objLen = nmObj.length;
      if (file.response[0].type == 'image/jpeg') {
        file.response[0].ext = '.jpg';
        if (this.fileIndex == 1) {
          this.generateThumb(file.response[0]);
        }
      } else if (file.response[0].type == 'application/pdf') {
        file.response[0].ext = '.pdf';
      }
      switch(this.fileIndex) {
        case 1: // 大頭照
                this.info1 = file.response[0];
                break;
        case 8: // 影本
                if (this.info2 != null) {
                  this.info2.push(file.response[0]);
                } else {
                  this.info2 = [file.response[0]];
                }
                break;
        case 2: // 學歷證明文件
                if (this.info3 != null) {
                  this.info3.push(file.response[0]);
                } else {
                  this.info3 = [file.response[0]];
                }
                break;
        case 5: // 報考身分
                if (this.info4 != null) {
                  this.info4.push(file.response[0]);
                } else {
                  this.info4 = [file.response[0]];
                }
                break;
        case 3: // 在校成績
                if (this.info8 != null) {
                  this.info8.push(file.response[0]);
                } else {
                  this.info8 = [file.response[0]];
                }
                break;
        case 9: // 修業計畫
                if (this.info9 != null) {
                  this.info9.push(file.response[0]);
                } else {
                  this.info9 = [file.response[0]];
                }
                break;
        case 10: // 身心障礙
                if (this.info10 != null) {
                  this.info10.push(file.response[0]);
                } else {
                  this.info10 = [file.response[0]];
                }
                break;
        default:
                if ((this.fileIndex >= 500) && (this.fileIndex < 600)) {  // 其他證明文件
                  var idx = Math.round((this.fileIndex - 500)/10);
                  //if (0 < idx) {
                  //  idx -= 1;
                  //}
                  if (this.info5 == null) {
                    this.info5 = [];
                  } else {
                    var aLen = (0 < this.info5.length ? this.info5.length : 0);
                    if (aLen <= idx) {
                      for (var x = aLen; x <= idx; x++) {
                        this.info5[x] = [];
                      }
                    }
                  }
                  if (this.info5[idx] != null) {
                    this.info5[idx].push(file.response[0]);
                  } else {
                    this.info5[idx] = [file.response[0]];
                  }
                } else if ((this.fileIndex >= 600) && (this.fileIndex < 700)) {  // 書面審查必繳資料
                  var idx = Math.round((this.fileIndex - 600)/10);
                  if (this.info6 == null) {
                    this.info6 = [];
                  } else {
                    var aLen = (0 < this.info6.length ? this.info6.length : 0);
                    if (aLen <= idx) {
                      for (var x = aLen; x <= idx; x++) {
                        this.info6[x] = [];
                      }
                    }
                  }
                  if (this.info6[idx] != null) {
                    this.info6[idx].push(file.response[0]);
                  } else {
                    this.info6[idx] = [file.response[0]];
                  }
                }
                else if ((this.fileIndex >= 700) && (this.fileIndex < 800)) {  // 書面審查選繳資料
                  var idx = Math.round((this.fileIndex - 700)/10);
                  if (this.info7 == null) {
                    this.info7 = [];
                  } else {
                    var aLen = (0 < this.info7.length ? this.info7.length : 0);
                    if (aLen <= idx) {
                      for (var x = aLen; x <= idx; x++) {
                        this.info7[x] = [];
                      }
                    }
                  }
                  if (this.info7[idx] != null) {
                    this.info7[idx].push(file.response[0]);
                  } else {
                    this.info7[idx] = [file.response[0]];
                  }
                }
                break;
      }
    },
    removeAllTempFiles(files, index, type) {
      if ((null != files) && (null != files[index])) {
        let vm = this
        var flag = false;
        for (var i = 0; i < files[index].length; i++, !flag) {
          if ('A' == files[index][i].status) {
            files[index][i].dataUrl = '';
            vm.$http.put('./WebApi/Tools/RemoveFiles',files[index])
                    .then((response) =>{
                      flag = true;
                      if (2 == type) {
                        for (var j = 0; j < files[index].length; j++) {
                          if ('A' == files[index][j].status) {
                            files[index][j].status = '';
                          }
                        }
                      }
                    })
                    .catch(function (error) {
                      //vm.$message.error('對不起,網路連線失敗');
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗</strong>',
                                        offset: 150
                                      });
                    });
          }
        }
      }
    },
    removeFile4Item(item, index) {
      if (null != item.info) {
        var fLen = item.info.length;
        for (var i = 0; i < fLen; i++) {
          item.info[i].status = 'R';
        }
      }

      this.removeAllTempFiles(this.info4, index, 2);
    },
    delTempFiles(files,tmpFiles, position) {
      if (null != files && null != files[position]) {
        if ('A' == files[position].status) {
          files.splice(position, 1);
          tmpFiles.splice(position, 1);
          this.removeAllTempFiles(position, 1);
        } else {
          if (null != files[position].info) {
            var fLen = files[position].info.length;
            for (var i = 0; i < fLen; i++){
              files[position].info[i].status = 'R';
            }
          }
          files[position].status = 'R';
        }
      }
    },
    delFile5Item(position) {
      if (null != this.inputData.othersInfo) {
        this.delTempFiles(this.inputData.othersInfo, this.info5, position);
      }
    },
    delFile6Item(position) {
      if (null != this.inputData.majorInfo) {
        this.delTempFiles(this.inputData.majorInfo, this.info6, position);
      }
    },
    delFile7Item(position) {
      if (null != this.inputData.minorInfo) {
        this.delTempFiles(this.inputData.minorInfo, this.info7, position);
      }
    },
    checkFileList(index, flag) {
      var ret = flag;

      if ((null != this.inputData.othersInfo) && 
          (index < this.inputData.othersInfo.length) && 
          (null != this.inputData.othersInfo[index].info)) {
        var fLen = this.inputData.othersInfo[index].info.length;
        if (fLen == 0) {
          ret = true;
        } else {
          var count = 0;
          for (var i = 0; i < fLen; i++) {
            if (this.inputData.othersInfo[index].info[i].status == 'R') {
              count++;
            }
          }
          ret = (fLen == count);
        }
      }
      if (ret) {
        if ((null != this.info5) && (0 < this.info5.length)) {
          return false;
        }
      }
      return ret;
    },
    checkMajorList(index, flag) {
        var ret = flag;
         
        //必繳
        if ((null != this.inputData.majorInfo) && 
            (index < this.inputData.majorInfo.length)&& 
            (null != this.inputData.majorInfo[index])) {
            var fLen = (null == this.inputData.majorInfo[index].info? 0 : this.inputData.majorInfo[index].info.length);
            if (fLen == 0) {
                ret = true;
            } else {
                var count = 0;
                for (var i = 0; i < fLen; i++) {
                    if (this.inputData.majorInfo[index].info[i].status == 'R') {
                        count++;
                    }
                }
                ret = (fLen == count);
            }
        }
        if (ret) {
            if ((null != this.info6) && (null != this.info6[index])) {
                var fLen = this.info6[index].length;
                for (var i = 0; i < fLen; i++) {
                    if (this.info6[index][i].status == 'A') {
                        return false;
                    }
                }
            }
        }
        return ret;
    },
    checkMinorList(index, flag) {
        var ret = flag;
         
        //選繳
        if ((null != this.inputData.minorInfo) &&
            (index < this.inputData.minorInfo.length) &&
            (null != this.inputData.minorInfo[index])) {
            var fLen = (null == this.inputData.minorInfo[index].info? 0 : this.inputData.minorInfo[index].info.length);
            if (fLen == 0) {
                ret = true;
            } else {
                var count = 0;
                for (var i = 0; i < fLen; i++) {
                    if (this.inputData.minorInfo[index].info[i].status == 'R') {
                        count++;
                    }
                }
                ret = (fLen == count);
            }
        }
        if (ret) {
            if ((null != this.info7) && (null != this.info7[index])) {
                var fLen = this.info7[index].length;
                for (var i = 0; i < fLen; i++) {
                    if (this.info7[index][i].status == 'A') {
                        return false;
                    }
                }
            }
        }
        return ret;
    },
    submit() {
      var vm = this;
      this.$confirm(this.successMsg[6].contText, '請注意', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '確定送出',
          cancelButtonText: '我要返回暫存資料'
        }).then(() => {
          this.$http
              .get("./WebApi/Apply/GetEnrollTimeFg/".concat(this.setting.enrollID[0].codeName).concat("/").concat(this.user.groupID).concat("/").concat(this.enroll.statusID))
              .then(function(response) {
                if (!vm.isNull(response.data)) {
                  if (1 == response.data.id) {
                    if (vm.checkTabData()) {
                      vm.setPhoto(); 

                      vm.inputData.updateUser = vm.user.id;                  
                      vm.$http.put('./WebApi/Apply/SetInputData',vm.inputData)
                              .then((success) =>{                            
                                  if (!vm.isNullOrWhiteSpace(success.data)) {
                                    vm.$message({
                                        message: '恭喜您,存檔成功',
                                        type: 'success'
                                      });
                                    vm.inputData.regNo = success.data;
                                    vm.imageUrl = null;
                                    vm.saveFg = 1;
                                    //vm.showSuccessMsg();
                                  }
                              })
                              .catch(function (error) {
                                //vm.$message.error('對不起,網路連線失敗' + error);
                                vm.$notify.error({
                                                  title: vm.$t('message.Error_txt'),
                                                  dangerouslyUseHTMLString: true,
                                                  message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                                  offset: 150
                                                });
                              });
                    }
                  } else {
                    vm.saveFg = 2;
                  }
                } else {
                  vm.saveFg = 2;
                }
              })
            .catch(function (error) {
              //vm.$message.error('對不起,網路連線失敗' + error);
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                offset: 150
                              });
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消送件'
          });          
        });
    },
    keep(item) {
      var vm = this;
      this.$http
          .get("./WebApi/Apply/GetEnrollTimeFg/".concat(this.setting.enrollID[0].codeName).concat("/").concat(this.user.groupID).concat("/").concat(this.enroll.statusID))
          .then(function(response) {
            if (!vm.isNull(response.data)) {
              if (1 == response.data.id) {
                //if (vm.checkTabData()) {
                  vm.setPhoto(); 

                  vm.inputData.updateUser = vm.user.id;                  
                  vm.$http.put('./WebApi/Apply/KeepInputData',vm.inputData)
                          .then((success) =>{
                              if (vm.isSuccess(success.data)) {
                                vm.$message({
                                    message: '恭喜您,存檔成功',
                                    type: 'success'
                                  });
                                vm.getInputData(0); 
                                vm.resetPhoto();
                              }
                          })
                          .catch(function (error) {
                            //vm.$message.error('對不起,網路連線失敗' + error);
                            vm.$notify.error({
                                              title: vm.$t('message.Error_txt'),
                                              dangerouslyUseHTMLString: true,
                                              message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                              offset: 150
                                            });
                          });
                //}
              } else {
                vm.saveFg = 2;
              }
            } else {
              vm.saveFg = 2;
            }
          })
        .catch(function (error) {
          //vm.$message.error('對不起,網路連線失敗' + error);
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        });
    },
    clearImage(infoLst) {
      if (null != infoLst) {
        var len1 = infoLst.length;
        for (var it = 0; it < len1; it++) {
          if (infoLst[it].status == 'A') {
            infoLst[it].rowId = '';
          }
          
          infoLst[it].dataUrl = '';
          infoLst[it].img = '';
        }
      }
    },
    checkFileInfo(tInfo, inpInfo) {
      var len = tInfo.length;
      for (var it = 0; it < len; it++) {
        if (tInfo[it].status == 'A' || tInfo[it].rowId.length > 0) {
          inpInfo.push(tInfo[it]);
        }
      }
    },
    setPhoto() {
      // 照片
      if (null != this.info1) {
        if (null == this.inputData.info1) {
          this.inputData.info1 = [this.info1];
          //this.checkFileInfo(this.info1, this.inputData.info1);
        } else {
          var len = this.inputData.info1.length;
          for (var it = 0; it < len; it++) {
            this.inputData.info1[it].status = 'R';
          }
          this.inputData.info1.push(this.info1);

          //this.checkFileInfo(this.info1, this.inputData.info1);
        }
      }

      // 身分證影本
      // if (null != this.info2) {
      //   if (null == this.inputData.info2) {
      //     this.inputData.info2 = this.info2;
      //     // this.inputData.info2 = [];
      //     // this.checkFileInfo(this.info2, this.inputData.info2);
      //   } else {
      //     var len = this.inputData.info2.length;
      //     for (var it = 0; it < len; it++) {
      //       this.inputData.info2[it].status = 'R';
      //     }
      //     this.inputData.info2.push(this.info2);

      //     //this.checkFileInfo(this.info2, this.inputData.info2);
      //   }
      // }
      if (null != this.info2) {
        var len = this.info2.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info2[it].status) {
            if (null == this.inputData.info2) {
              this.inputData.info2 = [this.info2[it]];
            } else {
              this.inputData.info2.push(this.info2[it]);
            }
          }
        }
      }

      // 學歷證明文件
      if (null != this.info3) {
        var len = this.info3.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info3[it].status) {
            if (null == this.inputData.info3) {
              this.inputData.info3 = [this.info3[it]];
            } else {
              this.inputData.info3.push(this.info3[it]);
            }
          }
        }
      }

      //其他文件
      if (null != this.info4) {
        for (var i = 0; i < this.info4.length; i++) { 
          if ('' != this.info4[i].status) {
            if (null == this.inputData.othersInfo[0].info) {
              this.inputData.othersInfo[0].info = [this.info4[i]];
            } else {
              this.inputData.othersInfo[0].info.push(this.info4[i]);
            }
            if (this.inputData.othersInfo[0].status!='A') {                    
              this.inputData.othersInfo[0].status = 'M';
            }
          }
        }
      }

      // 在校成績
      if (null != this.info8) {
        var len = this.info8.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info8[it].status) {
            if (null == this.inputData.info6) {
              this.inputData.info6 = [this.info8[it]];
            } else {
              this.inputData.info6.push(this.info8[it]);
            }
          }
        }
      }
      
      // 在職證明
      if (null != this.info9) {
        var len = this.info9.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info9[it].status) {
            if (null == this.inputData.info7) {
              this.inputData.info7 = [this.info9[it]];
            } else {
              this.inputData.info7.push(this.info9[it]);
            }
          }
        }
      }

      // 身心障礙
      if (null != this.info10) {
        var len = this.info10.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info10[it].status) {
            if (null == this.inputData.info8) {
              this.inputData.info8 = [this.info10[it]];
            } else {
              this.inputData.info8.push(this.info10[it]);
            }
          }
        }
      }

      if (null != this.info5) {
        for (var i = 0; i < this.info5.length; i++) {
          if (null != this.info5[i]) {
            var tIdx = i + (null != this.info4? 1: 0);
            for (var it = 0; it < this.info5[i].length; it++) {
              if ('' != this.info5[i][it].status) {
                if (null == this.inputData.othersInfo[tIdx].info) {
                  var arry1 = [this.info5[i][it]];
                  this.inputData.othersInfo[tIdx].info = arry1;
                } else {
                  this.inputData.othersInfo[tIdx].info.push(this.info5[i][it]);
                }
                if (this.inputData.othersInfo[tIdx].status!='A') {                    
                  this.inputData.othersInfo[tIdx].status = 'M';
                }
              }
            }
          }
        }
      }

      //必繳
      if (null != this.info6) {
        for (var i = 0; i < this.info6.length; i++) {
          if (null != this.info6[i]) {
            for (var it = 0; it < this.info6[i].length; it++) {
              if ('' != this.info6[i][it].status) {
                if (null == this.inputData.majorInfo[i].info) {
                  this.inputData.majorInfo[i].info = [this.info6[i][it]];
                } else {
                  this.inputData.majorInfo[i].info.push(this.info6[i][it]);
                }
                if (this.inputData.majorInfo[i].status!='A') {                    
                  this.inputData.majorInfo[i].status = 'M';
                }
              }
            }
          }
        }
      }

      //選繳
      if (null != this.info7) {
        for (var i = 0; i < this.info7.length; i++) {
          if (null != this.info7[i]) {
            for (var it = 0; it < this.info7[i].length; it++) {
              if ('' != this.info7[i][it].status) {
                if (null == this.inputData.minorInfo[i].info) {
                  this.inputData.minorInfo[i].info = [this.info7[i][it]];
                } else {
                  this.inputData.minorInfo[i].info.push(this.info7[i][it]);
                }
                if (this.inputData.minorInfo[i].status!='A') {                    
                  this.inputData.minorInfo[i].status = 'M';
                }
              }
            }
          }
        }
      }
      
      if (null != this.inputData.info1) {
        this.clearImage(this.inputData.info1);
      }
      if (null != this.inputData.info2) {
        this.clearImage(this.inputData.info2);
      }
      if (null != this.inputData.info3) {
        this.clearImage(this.inputData.info3);
      }
      if (null != this.inputData.info6) {
        this.clearImage(this.inputData.info6);
      }
      if (null != this.inputData.info7) {
        this.clearImage(this.inputData.info7);
      }
      if (null != this.inputData.othersInfo) {
        for (var i = 0; i < this.inputData.othersInfo.length; i++) {
          if (null != this.inputData.othersInfo[i].info) {
            this.clearImage(this.inputData.othersInfo[i].info);
          }
        }
      }
      if (null != this.inputData.majorInfo) {
        for (var i = 0; i < this.inputData.majorInfo.length; i++) {
          if (null != this.inputData.majorInfo[i].info) {
            this.clearImage(this.inputData.majorInfo[i].info);
          }
        }
      }
      if (null != this.inputData.minorInfo) {
        for (var i = 0; i < this.inputData.minorInfo.length; i++) {
          if (null != this.inputData.minorInfo[i].info) {
            this.clearImage(this.inputData.minorInfo[i].info);
          }
        }
      }
    },
    checkExtName(fileObj) {
      var tObj = fileObj;
      var nAry = tObj.name.split("\\");
      tObj.name = nAry[nAry.length - 1];
      if (tObj.name.indexOf(tObj.ext) == tObj.name.length - tObj.ext.length) {
        tObj.ext = '';
      }
      tObj.status = '';
      return tObj;
    },
    resetPhoto() {
      if (null != this.info1) {
        this.info1 = null;
      }
      if (null != this.info2) {
        this.info2 = null;
      } 
      if (null != this.info3) {
        this.info3 = null;
      } 
      if (null != this.info4) {
        this.info4 = null;
      }
      if (null != this.info5) {
        this.info5 = null;
      }
      if (null != this.info6) {
        this.info6 = null;
      }
      if (null != this.info7) {
        this.info7 = null;
      }
      if (null != this.info8) {
        this.info8 = null;
      }
      if (null != this.info9) {
        this.info9 = null;
      }
      if (null != this.info10) {
        this.info10 = null;
      }
      this.imageUrl = null;
      const mainImg = this.$refs.upload;
      if (mainImg && mainImg.length) {
        mainImg.forEach(item => {
          item.clearFiles();
        })
      }

      if (null != this.inputData) {
        if (null != this.inputData.info1) {
          var tmpFile = [];
          var len = this.inputData.info1.length;
          for (var it = 0; it < len; it++) {
            if (this.inputData.info1[it].status != 'R') {
              var tObj = this.checkExtName(this.inputData.info1[it]);
              tmpFile.push(tObj);
            }
          }
          this.inputData.info1 = tmpFile;
        }

        if (null != this.inputData.info2) {
          var tmpFile = [];
          var len = this.inputData.info2.length;
          for (var it = 0; it < len; it++) {
            if (this.inputData.info2[it].status != 'R') {
              var tObj = this.checkExtName(this.inputData.info2[it]);
              tmpFile.push(tObj);
            }
          }
          this.inputData.info2 = tmpFile;
        }
             
        if (null != this.inputData.info3) {
          var tmpFile = [];
          var len = this.inputData.info3.length;
          for (var it = 0; it < len; it++) {
            if (this.inputData.info3[it].status != 'R') {
              var tObj = this.checkExtName(this.inputData.info3[it]);
              tmpFile.push(tObj);
            }
          }
          this.inputData.info3 = tmpFile;
        }

        // 在校成績
        if (null != this.inputData.info6) {
          var tmpFile = [];
          var len = this.inputData.info6.length;
          for (var it = 0; it < len; it++) {
            if (this.inputData.info6[it].status != 'R') {
              var tObj = this.checkExtName(this.inputData.info6[it]);
              tmpFile.push(tObj);
            }
          }
          this.inputData.info6 = tmpFile;
        }

        // 修業計畫
        if (null != this.inputData.info7) {
          var tmpFile = [];
          var len = this.inputData.info7.length;
          for (var it = 0; it < len; it++) {
            if (this.inputData.info7[it].status != 'R') {
              var tObj = this.checkExtName(this.inputData.info7[it]);
              tmpFile.push(tObj);
            }
          }
          this.inputData.info7 = tmpFile;
        }

        // 身心障礙
        if (null != this.inputData.info8) {
          var tmpFile = [];
          var len = this.inputData.info8.length;
          for (var it = 0; it < len; it++) {
            if (this.inputData.info8[it].status != 'R') {
              var tObj = this.checkExtName(this.inputData.info8[it]);
              tmpFile.push(tObj);
            }
          }
          this.inputData.info8 = tmpFile;
        }

        if (null != this.inputData.othersInfo) {
          var mTmpFile = [];
          for (var i = 0; i < this.inputData.othersInfo.length; i++) {
            if ('R' != this.inputData.othersInfo[i].status) {
              if (null != this.inputData.othersInfo[i].info) {
                var tmpFile = [];
                var len = (null != this.inputData.othersInfo[i].info ? this.inputData.othersInfo[i].info.length : 0);
                for (var j = 0; j < len; j++) {
                  if (this.inputData.othersInfo[i].info[j].status != 'R') {
                    var tObj = this.checkExtName(this.inputData.othersInfo[i].info[j]);
                    tmpFile.push(tObj);
                  }
                }
                this.inputData.othersInfo[i].info = tmpFile;
              }
              mTmpFile.push(this.inputData.othersInfo[i]);
            }
          }
          this.inputData.othersInfo = mTmpFile;
        }

        if (null != this.inputData.majorInfo) {
          var mTmpFile = [];
          for (var i = 0; i < this.inputData.majorInfo.length; i++) {
            if ('R' != this.inputData.majorInfo[i].status) {
              if (null != this.inputData.majorInfo[i].info) {
                var tmpFile = [];
                var len = (null != this.inputData.majorInfo[i].info ? this.inputData.majorInfo[i].info.length : 0);
                for (var j = 0; j < len; j++) {
                  if (this.inputData.majorInfo[i].info[j].status != 'R') {
                    var tObj = this.checkExtName(this.inputData.majorInfo[i].info[j]);
                    tmpFile.push(tObj);
                  }
                }
                this.inputData.majorInfo[i].info = tmpFile;
              }
              mTmpFile.push(this.inputData.majorInfo[i]);
            }
          }
          this.inputData.majorInfo = mTmpFile;
        }

        if (null != this.inputData.minorInfo) {
          var mTmpFile = [];
          for (var i = 0; i < this.inputData.minorInfo.length; i++) {
            if ('R' != this.inputData.minorInfo[i].status) {
              if (null != this.inputData.minorInfo[i].info) {
                var tmpFile = [];
                var len = (null != this.inputData.minorInfo[i].info ? this.inputData.minorInfo[i].info.length : 0);
                for (var j = 0; j < len; j++) {
                  if (this.inputData.minorInfo[i].info[j].status != 'R') {
                    var tObj = this.checkExtName(this.inputData.minorInfo[i].info[j]);
                    tmpFile.push(tObj);
                  }
                }
                this.inputData.minorInfo[i].info = tmpFile;
              }
              mTmpFile.push(this.inputData.minorInfo[i]);
            }
          }
          this.inputData.minorInfo = mTmpFile;
        }
      }
    }
  },
  mounted() {
    this.sysDoc.then(pdf => {
      this.numPages = pdf.numPages;
    });
  },
  created() { 
    console.log('======created EnrollCCEView=====');
    var userAgent = navigator.vendor;
    let vm = this;
    if (userAgent.indexOf("Apple") > -1) {
        this.isSafari = true;
    } else {
      this.isSafari = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
    }
    this.$http
        .get("./WebApi/Apply/GetEnrollTimeFg/".concat(this.setting.enrollID[0].codeName).concat("/").concat(this.user.groupID).concat("/").concat(this.enroll.statusID))
        .then(function(response) {
              if (null != response.data) {
                if (1 == response.data.id) {
                  vm.getInputData(1);
                } else {
                  vm.saveFg = 2;
                }
              } else {
                vm.saveFg = 2;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                offset: 150
                              });
        });
        this.showSuccessMsg();
    },
    watch: {
      fileData (newId, oldId) {
        var fileName = '';
        if (null != newId) {
          this.fileFormDataName = this.changeFileName(newId.name, "f" + this.inputData.documentID + "_" + this.fileIndex);
        } else {
          this.fileFormDataName = "f" + this.inputData.documentID + "_" + this.fileIndex;
        }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .doc-title {
    padding: 0.5em;
    font-weight: bolder; 
    width:12em;
  }
  .modal-show {
    transition: transform 0.3s ease-out 0s;  
    transform: translate(0px, 0px);
    z-index: 1050;
    display: block;
    opacity: 1;
    position: relative;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .enroll-p {
    display:flex; 
    padding:0.2em; 
    margin: 0;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"]{
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnrollCCEView.vue